import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import httpclient from "../../utilsFulfill";
import {
  AppBar,
  Box,
  Button,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  Tab,
  Tabs,
  TextField,
  styled,
  useMediaQuery,
  useTheme,
  Snackbar,
  Backdrop,
  Autocomplete,
  DialogTitle,
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";

import PropTypes from "prop-types";
import OrderCard from "../../Components/Warehouse1/WarehouseOrderCard";
import { Masonry } from "@mui/lab";
import PickupList from "../../Components/Warehouse1/PickupList";
import {

  DoneAllOutlined,

} from "@mui/icons-material";
import PrintDialog from "../../Components/PrintDialog";
import TableComponentView from "../../Components/TableComponentView";
import ViewWarehouseOrderList from "../../Components/Warehouse1/ViewWarehouseOrderList";
import SelectView from "../../Components/SelectView";
import ButtonDropDown from "../../Components/ButtonDropDown";
import TableNotification from "../../Components/TableNotification";
import ViewNotification from "../../Components/Warehouse/ViewNotification";
import ViewHistory from "../../Components/Warehouse/ViewHistory";
import ExpressOrderComponent from "../../Components/Warehouse1/ToPickOrderComponent";
import InstoreOrderComponent from "../../Components/Warehouse/InstoreOrderComponent";
import ToPickOrderComponent from "../../Components/Warehouse1/ToPickOrderComponent";
import PreparingOrderComponent from "../../Components/Warehouse1/PreparingOrderComponent";
import ViewWarehouseOrderHistory from "../../Components/Warehouse1/ViewWarehouseOrderHistory";
import ButtonDropDown1 from "../../Components/ButtonDropDown1";
import useInactivityTimer from "../../customHooks/useInactivityTimer";
import moment from "moment/moment";
import featureServer from "../../FeatureServer/featureServer";
import GlobalURL from "../../utils/global";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const AddDetails = (props) => {

  const [dialogDetails, setDialogDetails] = useState({
    open: true,
    success: false,
  });
  const [details, setDetails] = React.useState('');


  useEffect(() => {
    if (props.salesIDs === "") {
      props.sendToMarkOrder(props.order, dialogDetails, details);
    } else {
      props.sendToMark(dialogDetails, details);
    }
  }, [dialogDetails, details]);


  const handleClose = () => {
    setDialogDetails({
      ...dialogDetails,
      open: false,
    });
  };

  const handleYes = () => {

    setDialogDetails({
      ...dialogDetails,
      open: false,
      success: true,

    });

  };

  const handleChange = (e) => {
    setDetails(e.target.value);

  };

  const salesIDsArray = props.salesIDs?.split(',');


  const filteredData = props.data?.filter(data => data.orderSequence === 2);


  const hasMatchingSalesID = filteredData.some(data => salesIDsArray.includes(data.id.toString()));

  // console.log("dialog props", salesIDsArray, filteredData, hasMatchingSalesID);

  return (
    <div>
      <Dialog
        open={dialogDetails.open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Are you sure you want to mark this order as collected?
        </DialogTitle>
        <DialogContent>
          {/* <Box pt={3} >Are you sure you want to cancel this order? </Box> */}
          {(props.order.orderSequence === 2 || hasMatchingSalesID) && (
            <>
              <Box pt={3} > {(props.order.orderSequence === 2 || hasMatchingSalesID) ? `Enter Driver's Name Here` : `Enter any pickup comments`}</Box>
              <Box pt={2} sx={{ minWidth: 240 }}>

                <TextField
                  //required
                  variant="outlined"
                  name="details"
                  label={(props.order.orderSequence === 2 || hasMatchingSalesID) ? `` : `Optional`}
                  type="text"
                  onChange={handleChange}
                  value={details}
                  error={!details && (props.order.orderSequence === 2 || hasMatchingSalesID)}
                  helperText={(props.order.orderSequence === 2 || hasMatchingSalesID) ? `Required Field` : ``}

                  fullWidth
                />


              </Box>
            </>
          )}

        </DialogContent>
        <DialogActions styled={{ margin: "5px 10px" }}>
          <Button onClick={handleClose} color="error" variant="contained" autoFocus>
            No
          </Button>
          <Button
            onClick={handleYes}
            color="primary"
            variant="contained"
            autoFocus
            //(props.order.orderSequence === 2 || hasMatchingSalesID) && 
            disabled={!details && (props.order.orderSequence === 2 || hasMatchingSalesID)} // Disable the button when no reason is selected
          >
            Yes
          </Button>

        </DialogActions>
      </Dialog>
    </div>
  );
};



const SearchBox = styled(Box)(({ theme }) => ({
  "& input": {
    padding: "12px",
  },
}));

const NotificationBox = styled(Box)(({ theme }) => ({
  margin: "10px 0",
  "& span": {
    padding: "10px 15px",
    border: "1px solid #f1f1f1",
    marginRight: "20px",
    borderRadius: "6px",
  },
}));


const FlexContent = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  fontSize: "17px",
  marginBottom: "10px",
  alignItems: "flex-start",
  [theme.breakpoints.down('md')]: {
    flexDirection: "column",

  },
}));

const FlexInnerTitle = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-between",
  minWidth: "220px",
  fontWeight: "400",
}));


const columns = [
  { id: "check", name: " " },
  { id: "salesid", name: "Sales ID" },
  { id: "dlvmode", name: "Delivery Type" },
  { id: "salesname", name: "Sales Name" },
  { id: "documenttype", name: "Sales Type" },
  { id: "salespoolid", name: "Sales Pool" },
  // { id: "document_status", name: "Document Status" },
  { id: "school_info", name: "School" },
  // { id: "inventlocationname", name: "Location" },


  { id: "total_lines", name: "Total Items" },
  // { id: "fulfill", name: "Fulfilled Items" },
  // { id: "fulfill_percentage", name: "Fulfill %" },
  { id: "actions", name: "Actions" },
];

const columnsReadyForCollection = [
  { id: "check", name: " " },
  { id: "salesid", name: "Sales ID" },
  { id: "dlvmode", name: "Delivery Type" },
  { id: "RFCD", name: "Ready For Collection Date" },
  { id: "salesname", name: "Sales Name" },
  { id: "documenttype", name: "Sales Type" },
  { id: "salespoolid", name: "Sales Pool" },
  // { id: "document_status", name: "Document Status" },
  { id: "school_info", name: "School" },
  // { id: "inventlocationname", name: "Location" },


  { id: "total_lines", name: "Total Items" },
  // { id: "fulfill", name: "Fulfilled Items" },
  // { id: "fulfill_percentage", name: "Fulfill %" },
  { id: "actions", name: "Actions" },
];

const columnsToPick = [
  { id: "check", name: " " },
  { id: "salesid", name: "Sales ID" },
  { id: "dlvmode", name: "Delivery Type" },
  { id: "salesname", name: "Sales Name" },
  { id: "documenttype", name: "Sales Type" },
  { id: "salespoolid", name: "Sales Pool" },
  // { id: "document_status", name: "Document Status" },
  { id: "school_info", name: "School" },
  // { id: "inventlocationname", name: "Location" },


  { id: "total_lines", name: "Total Items" },
  { id: "fulfill", name: "Fulfilled Items" },
  { id: "fulfill_percentage", name: "Fulfill %" },
  { id: "actions", name: "Actions" },
];

const columnsInvoiced = [
  { id: "check", name: " " },
  { id: "salesid2.0", name: "Sales ID" },
  { id: "salesAxID", name: "REC ID" },
  { id: "dlvmode2.0", name: "Delivery Type" },
  { id: "invoicedDate", name: "Invoiced Date" },
  { id: "salesname2.0", name: "Sales Name" },
  { id: "sales_type2.0", name: "Sales Type" },
  { id: "salespoolid2.0", name: "Sales Pool" },
  { id: "isInvoiced", name: "Status" },
  { id: "total_lines2.0", name: "Total Items" },
  { id: "actions", name: "Actions" },
];

const columnsNotification = [
  { id: "check", name: " " },
  { id: "orderNumber", name: "Order Number" },
  { id: "fromEmail", name: "From Email" },
  { id: "toEmail", name: "To Email" },
  { id: "created_at", name: "Created Date" },
  { id: "updated_at", name: "Updated Date" },
  { id: "pendingProcess", name: "Status" },
  { id: "actions", name: "Actions" },
];

const columnsNotificationSMS = [
  { id: "check", name: " " },
  { id: "orderNumber", name: "Order Number" },
  { id: "customerName", name: "Customer Name" },
  { id: "fromStore", name: "From Store" },
  { id: "created_at", name: "Created Date" },
  { id: "updated_at", name: "Updated Date" },
  { id: "status", name: "Status" },
  { id: "actions", name: "Actions" },
];

const columnsPicked = [
  { id: "check1", name: " " },
  { id: "salesid", name: "Sales ID" },
  { id: "dlvmode", name: "Delivery Type" },
  { id: "salesname", name: "Sales Name" },
  { id: "documenttype", name: "Sales Type" },
  { id: "salespoolid", name: "Sales Pool" },
  // { id: "document_status", name: "Document Status" },
  { id: "school_info", name: "School" },

  { id: "pickedDatetime", name: "Picked Date & Time" },


  { id: "total_lines", name: "Total Items" },
  // { id: "fulfill", name: "Fulfilled Items" },
  // { id: "fulfill_percentage", name: "Fulfill %" },
  { id: "actions", name: "Actions" },
];

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3, pb: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const WarehouseOrders = (props) => {
  const resetInactivityTimer = useRef(null);
  const configRowPerPage = JSON.parse(localStorage.getItem("configRowPerPage"));
  const sessionTabValue = JSON.parse(sessionStorage.getItem("tabValue"));
  const navigate = useNavigate();
  const { id } = useParams();
  const [orderList, setOrderList] = useState([]);
  const [pickupList, setPickupList] = useState([]);
  const [pickupOrder, setPickupOrder] = useState([]);
  const [notificationList, setNotificationList] = useState([]);
  const [notificationListSMS, setNotificationListSMS] = useState([]);
  const [fulfilledOrderList, setFulfilledOrderList] = useState([]);
  const [readyPickedList, setReadyPickedList] = useState([]);
  const [pickedList, setPickedList] = useState([]);
  const [readyforCollection, setReadyForCollection] = useState([0, 2]);
  const [showPrintDialog, setShowPrintDialog] = useState(false);
  const [printDetails, setPrintDetails] = useState("");
  const [view, setView] = useState(1);
  const initialReadyForCollection = "0,2";
  const [searchText, setSearchText] = useState("");
  const [searchText2, setSearchText2] = useState("");
  const [searchText3, setSearchText3] = useState("");
  const [searchText4, setSearchText4] = useState("");
  const [searchNotification, setSearchNotification] = useState("");
  const [searchTextPicked, setSearchTextPicked] = useState("");
  const [searchTextPicked1, setSearchTextPicked1] = useState("");
  const [searchTextInvoiced, setSearchTextInvoiced] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [filteredData2, setFilteredData2] = useState([]);
  const [filteredData3, setFilteredData3] = useState([]);
  const [filteredData4, setFilteredData4] = useState([]);
  const [filteredData4SMS, setFilteredData4SMS] = useState([]);
  const [filteredDataPicked, setFilteredDataPicked] = useState([]);
  const [filteredDataPicked1, setFilteredDataPicked1] = useState([]);
  const [filteredDataInvoiced, setFilteredDataInvoiced] = useState([]);
  const [dateFilter, setDateFilter] = useState("1Day");
  const [expressList, setExpressList] = useState([]);
  const [notificationType, setNotificationType] = useState("email");
  const [check, setCheck] = useState(false);
  const [print, setPrint] = useState(false);
  const [orderDetails, setOrderDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingNots, setLoadingNots] = useState(false);
  const [loadingToPrint, setLoadingToPrint] = useState(false);
  const [loadingToPick, setLoadingToPick] = useState(false);
  const [loadingToPick1, setLoadingToPick1] = useState(false);
  const [loadingPreparing, setLoadingPreparing] = useState(false);
  const [loadingInvoiced, setLoadingInvoiced] = useState(false);
  var [currSalesDocumentID, setCurrSalesDocumentID] = useState("");
  const [expressSalesDocumentID, setExpressSalesDocumentID] = useState("");
  const [currOrderNumbers, setCurrOrderNumbers] = useState(0);
  const [checkedValues, setCheckedValues] = useState([]);
  const [markCheckValues, setMarkCheckValues] = useState([]);
  const [salesIDs, setSalesIDs] = useState("");
  const [openNotification, setOpenNotification] = useState(false);
  const [notificationDetails, setNotificationDetails] = useState({});

  const [openHistoryDialog, setOpenHistoryDialog] = useState(false);
  const [historyDetails, setHistoryDetails] = useState("");

  //snackbar msg
  const [open, setOpen] = useState(false);
  const [snackStatus, setSnackStatus] = useState("");
  const [snackMessage, setSnackMessage] = useState("");
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [backdropNumber, setBackdropNumber] = useState(5);

  //order count
  const [toBePickedOrdersCount, setToBePickedOrdersCount] = useState(0);
  const [preparingOrdersCount, setPreparingOrdersCount] = useState(0);
  const [scriptLastSynced, setScriptLastSynced] = useState(null);
  const [readyForCollectionOrdersCount, setReadyForCollectionOrdersCount] = useState(0);
  const [pickedOrdersCount, setPickedOrdersCount] = useState(0);
  const [notificationCount, setNotificationCount] = useState(0);
  const [invoicedCount, setInvoicedCount] = useState(0);
  //tabValue
  const [value, setValue] = useState(sessionTabValue ? sessionTabValue : 0);
  const [transferValue, setTransferValue] = useState(0);
  const [expressPrintedValue, setExpressPrintedValue] = useState(0);

  const [orderName, setOrderName] = useState("");
  const [orderCode, setOrderCode] = useState("");
  const [openViewDetails, setOpenViewDetails] = useState(false);
  const [openViewHistoryDetails, setOpenViewHistoryDetails] = useState(false);
  const [openMarkDialog, setOpenMarkDialog] = useState(false);
  const [viewDetails, setViewDetails] = useState("");
  const [viewHistoryDetails, setViewHistoryDetails] = useState("");

  //pagination
  const [page, setPage] = useState(1);
  const [from, setFrom] = useState(1);
  const [to, setTo] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [rowsPerPage, setRowsPerPage] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [total, setTotal] = useState(0);
  const [lastPage, setLastPage] = useState("");
  //pagination

  //notification pagination
  const [pageNots, setPageNots] = useState(1);
  const [fromNots, setFromNots] = useState(1);
  const [toNots, setToNots] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [rowsPerPageNots, setRowsPerPageNots] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [totalNots, setTotalNots] = useState("");
  const [lastPageNots, setLastPageNots] = useState("");
  //notification pagination

  //notification pagination
  const [pageNotsSMS, setPageNotsSMS] = useState(1);
  const [fromNotsSMS, setFromNotsSMS] = useState(1);
  const [toNotsSMS, setToNotsSMS] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [rowsPerPageNotsSMS, setRowsPerPageNotsSMS] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [totalNotsSMS, setTotalNotsSMS] = useState("");
  const [lastPageNotsSMS, setLastPageNotsSMS] = useState("");
  //notification pagination

  //express pagination
  const [pageExpress, setPageExpress] = useState(1);
  const [fromExpress, setFromExpress] = useState(1);
  const [toExpress, setToExpress] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [rowsPerPageExpress, setRowsPerPageExpress] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [totalExpress, setTotalExpress] = useState(0);
  const [lastPageExpress, setLastPageExpress] = useState("");
  //express pagination

  //invoiced pagination
  const [pageInvoiced, setPageInvoiced] = useState(1);
  const [fromInvoiced, setFromInvoiced] = useState(1);
  const [toInvoiced, setToInvoiced] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [rowsPerPageInvoiced, setRowsPerPageInvoiced] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [totalInvoiced, setTotalInvoiced] = useState(0);
  const [lastPageInvoiced, setLastPageInvoiced] = useState("");
  //invoiced pagination

  //fulfilled pagination
  const [pageFul, setPageFul] = useState(1);
  const [fromFul, setFromFul] = useState(1);
  const [toFul, setToFul] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [rowsPerPageFul, setRowsPerPageFul] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [totalFul, setTotalFul] = useState("");
  const [lastPageFul, setLastPageFul] = useState("");
  //fulfilled pagination

  //ready for Collection pagination
  const [pagePicked, setPagePicked] = useState(1);
  const [pagePicked1, setPagePicked1] = useState(1);
  const [fromPicked, setFromPicked] = useState(1);
  const [toPicked, setToPicked] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [fromPicked1, setFromPicked1] = useState(1);
  const [toPicked1, setToPicked1] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [rowsPerPagePicked, setRowsPerPagePicked] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [rowsPerPagePicked1, setRowsPerPagePicked1] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [totalPicked, setTotalPicked] = useState(0);
  const [totalPicked1, setTotalPicked1] = useState(0);
  const [lastPagePicked, setLastPagePicked] = useState("");
  const [lastPagePicked1, setLastPagePicked1] = useState("");
  //ready for Collection pagination

  const [rows, setRows] = useState([]);
  const [delivery, setDelivery] = useState([]);
  const [salesPoolID, setSalesPoolID] = useState([]);
  const [customerDetails, setCustomerDetails] = useState({});
  const [schoolData, setSchoolData] = useState({});
  const [schools, setSchools] = useState([]);
  const [orderPick, setOrderPick] = useState({});
  const [deliveryType, setDeliveryType] = useState("");
  const [documentStatus, setDocumentStatus] = useState("");
  const [documentType, setDocumentType] = useState("");
  const [salespool, setSalesPool] = useState("");
  const [fullfillPercentage, setfulfillPercentage] = useState("");

  //user inactivity

  const handleInactivity = () => {
    console.log("You have been inactive for a while!");

    if (resetInactivityTimer.current) {
      resetInactivityTimer.current();
    }

    switch (props.index) {
      case "to_pick":
        getExpressOrders();
        break;
      case "to_prepare":
        getOrderList();
        break;
      case "ready_to_be_picked":
        getReadyToBePicked();
        break;
      case "notification":
        getNotificationLists();
        break;
      case "invoiced":
        getInvoicedLists();
        break;
      case "picked":
        getPicked();
        break;
      default:
        break;
    }
  };

  resetInactivityTimer.current = useInactivityTimer(60000, handleInactivity, props.index);

  //userInactivity

  const getColorForOption = (optionValue) => {
    switch (optionValue) {
      case "1":
        return { backgroundColor: "#E6E6FA" };
      case "2":
        return { backgroundColor: "#FC8EAC" };
      case "3":
        return { backgroundColor: "#FFD580" };
      case "4":
        return { backgroundColor: "#ffcccb" };
      default:
        return {};
    }
  }

  const handleDeliveryChange = (event) => {
    setDeliveryType(event.target.value);

  };
  const handleDocumentStatus = (event) => {
    setDocumentStatus(event.target.value);

  };
  const handleSalesChange = (event) => {
    setDocumentType(event.target.value);
  };
  const handleFulfillChange = (event) => {
    setfulfillPercentage(event.target.value);
  };

  const handleSalesPoolChange = (event) => {
    setSalesPool(event.target.value);
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {

    //getAllCustomers();
    getAllSchools();
    getDeliveryType();
    getSalesPoolID();


  }, []);


  // const getAllCustomers = () => {
  //   httpclient
  //     .get(
  //       `getCustomers?isAllCustomer=1&warehouseID=${id}`
  //     )
  //     .then(({ data }) => {
  //       if (data.status === 200) {
  //         const rows = data.records;

  //         setRows(rows);



  //       } else {
  //         console.log("Error!");
  //       }
  //     });
  // };

  const getAllSchools = () => {
    httpclient
      .get(
        `getSchools?&warehouseID=${id}`
      )
      .then(({ data }) => {
        if (data.status === 200) {
          setSchools(data.records);
        } else {
          console.log("Error!");
        }
      });
  };

  const getDeliveryType = () => {
    httpclient
      .get(
        `getDeliveryModes`
      )
      .then(({ data }) => {
        if (data.status === 200) {
          const rows = data.records;

          setDelivery(rows);



        } else {
          console.log("Error!");
        }
      });
  };

  const getSalesPoolID = () => {
    httpclient
      .get(
        `getSalesPools`
      )
      .then(({ data }) => {
        if (data.status === 200) {
          const rows = data.records;

          setSalesPoolID(rows);



        } else {
          console.log("Error!");
        }
      });
  };

  // const handleChangeCustomer = (e) => {
  //   const { name, value } = e.target;

  //   setCustomerDetails({
  //     ...customerDetails,
  //     [name]: value,
  //   });
  // };

  // const handleSearchFilter = (value) => {

  //   setCustomerDetails({
  //     ...customerDetails,
  //     name: value !== null ? value.accountnum : "",
  //   });

  // };

  const handleChangeSchool = (e) => {
    const { name, value } = e.target;

    setSchoolData({
      ...schoolData,
      [name]: value,
    });
  };

  const handleSearchSchoolFilter = (value) => {

    setSchoolData({
      ...schoolData,
      name: value !== null ? value.SchoolName : "",
      id: value !== null ? value.SchoolID : "",
    });

  };

  // const sortedOptions = React.useMemo(() => {
  //   const inputValue = customerDetails.name || "";

  //   const matchedInitialLetters = [];
  //   const remainingOptions = [];

  //   rows.forEach((option) => {
  //     const name = option.name || "";

  //     if (
  //       name &&
  //       name.toLowerCase().startsWith(inputValue.toLowerCase())
  //     ) {
  //       matchedInitialLetters.push(option);
  //     } else {
  //       remainingOptions.push(option);
  //     }
  //   });

  //   return [...matchedInitialLetters, ...remainingOptions];
  // }, [customerDetails.name, rows]);

  const sortedSchools = React.useMemo(() => {
    const inputValue = schoolData.name || "";

    const matchedInitialLetters = [];
    const remainingOptions = [];

    schools.forEach((option) => {
      console.log("op", option);
      const name = option.SchoolName || "";

      if (
        name &&
        name.toLowerCase().startsWith(inputValue.toLowerCase())
      ) {
        matchedInitialLetters.push(option);
      } else {
        remainingOptions.push(option);
      }
    });

    return [...matchedInitialLetters, ...remainingOptions];
  }, [schoolData.name, schools]);


  const handleChange = (event, newValue) => {


    setValue(newValue);


    navigate(`/warehouse_orders/orders/${id}/tab_${newValue}`);

  };

  const handleChangeExpressTab = (event, newValue) => {

    setExpressPrintedValue(newValue);
    setSearchText3("");
    navigate(`/warehouse_orders/orders/${id}/tab_${newValue}`);
  };

  const handleChangeInstoretab = (event, newValue) => {

    setSearchText("");
    navigate(`/warehouse_orders/orders/${id}/tab_${newValue}`);
  };

  useEffect(() => {
    if (props.index !== "notification" && props.index !== "invoiced") {

      handleFilter();
    }
    if (props.index === "notification") {
      handleFilterNotification();
    }

    if (props.index === "invoiced") {
      handleFilterInvoiced();
    }

  }, [searchNotification, searchTextInvoiced, customerDetails.name, schoolData.id, deliveryType, documentType, documentStatus, salespool, fullfillPercentage])

  useEffect(() => {

    handleResetFilter();
    handleResetSearch();

  }, [notificationType, props.index, props.expressIndex])

  useEffect(() => {
    getOrderCount();
    getOrderList();
    setMarkCheckValues([]);

    if (props.index === "to_pick") {
      //handleFilter();
      getExpressOrders();
      setOrderDetails({});
      setPickupOrder([]);
      setCheckedValues([]);
    }

    if (props.index === "to_prepare") {
      //   getOrderList();
      getOrderList();
      setOrderDetails({});
      setPickupOrder([]);
      //setOrderName("");
      setCheckedValues([]);
    }

    if (props.index === "pickup") {
      setCheckedValues([]);
    }

    // if (props.index === "fulfilled") {
    //   getFulfilledOrders();
    //   setPickupOrder([]);
    //   setOrderDetails({});
    //   setOrderName("");
    //   setCheckedValues([]);
    // }

    if (props.index === "ready_to_be_picked") {
      getReadyToBePicked();
      setPickupOrder([]);
      setOrderDetails({});
      setOrderName("");
      setCheckedValues([]);
    }
    if (props.index === "invoiced") {
      getInvoicedLists();
      setPickupOrder([]);
      setOrderDetails({});
      setOrderName("");
      setCheckedValues([]);
    }

    if (props.index === "notification") {
      getNotificationLists();
      setPickupOrder([]);
      setOrderDetails({});
      setOrderName("");
      setCheckedValues([]);
    }

    if (props.index === "picked") {
      getPicked();
      setPickupOrder([]);
      setOrderDetails({});
      setOrderName("");
      setCheckedValues([]);
    }

    // if (props.index === "notification") {
    //   // console.log("notification type", notificationType);

    //   getNotificationLists();
    //   setPickupOrder([]);
    //   setOrderDetails({});
    //   setOrderName("");
    //   setCheckedValues([]);
    // }
  }, [
    id,
    props.index,
    transferValue,
    notificationType,
    props.expressIndex,
    props.instoreIndex,
  ]);



  // useEffect(() => {
  //   if (currSalesDocumentID || expressSalesDocumentID) {
  //     const getOrderDocInterval = setInterval(getOrderUsingDocumentID, 10000);

  //     return () => {
  //       clearInterval(getOrderDocInterval);
  //     };
  //   }
  // });

  useEffect(() => {
    const getCountInterval = setInterval(getOrderCount, 20000);
    return () => {
      clearInterval(getCountInterval);
    };
  });

  useEffect(() => {
    var number = localStorage.getItem("view");
    if (number) {
      var cookieViewNum = JSON.parse(number);
      setView(cookieViewNum);
    }
    setValue(sessionTabValue ? sessionTabValue : 0);
  }, []);

  // const getOrderUsingDocumentID = () => {
  //   if (props.index === "express" || props.index === "instore") {
  //     httpclient
  //       .get(
  //         `wms/orders?salesDocumentID=${props.index === "express"
  //           ? expressSalesDocumentID
  //           : currSalesDocumentID
  //         }&warehouseID=${id}&type=${props.index === "express" || props.index === "instore"
  //           ? props.index
  //           : ""
  //         }`
  //       )
  //       .then(({ data }) => {
  //         if (data.success) {
  //           setCurrOrderNumbers(data.records.total);
  //         }
  //       });
  //   }
  // };

  const getOrderCount = () => {
    httpclient.get(`getOrdersCount?warehouseID=${id}`).then(({ data }) => {
      if (data.success) {
        setToBePickedOrdersCount(data.records.toBePickedOrders);
        setPreparingOrdersCount(data.records.preparingOrders);
        setReadyForCollectionOrdersCount(data.records.readyForCollectionOrders);
        setPickedOrdersCount(data.records.pickedOrdersCount);
        setInvoicedCount(data.records.invoicedOrders);
        setNotificationCount(data.records.smsCount + data.records.emailCount);
        setScriptLastSynced(data.records.scriptLastSynced);
      }
    });
  };

  //Warehouse or Instore Order tab
  const getOrderList = () => {
    //console.log("instore index", props.instoreIndex);
    setLoading(true);
    httpclient
      .get(
        `getSalesOrders?version=v2&warehouseID=${id}&isPrinted=1&isPicked=${0}&document_status=${documentStatus === undefined ? '' : documentStatus}`
      )
      .then(({ data }) => {
        if (data.success) {
          setOrderList(data.records.data);
          setFilteredData(data.records.data);
          setLoading(false);
          setTotal(data.records.total);
          setRowsPerPage(parseInt(data.records.per_page));
          setPage(data.records.current_page);
          setFrom(data.records.from);
          setLastPage(data.records.last_page);
          setTo(data.records.to);

          getOrderCount();
          setCurrOrderNumbers(0);
          setBackdropNumber(5);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoading(false);
        }
        setLoading(false);
      });
  };

  const handleOrderChangePage = (e, page) => {
    setLoading(true);
    httpclient
      .get(
        `getSalesOrders?version=v2&warehouseID=${id}&isPrinted=1&isPicked=0&page=${page}&per_page=${rowsPerPage}&keyword=${searchText}&direction=asc&custaccount=${customerDetails.name === undefined ? '' : customerDetails.name
        }&sab_infocodeinformation=${schoolData.id === undefined ? '' : schoolData.id
        }&dlvmode=${deliveryType === undefined ? '' : deliveryType}&document_status=${documentStatus === undefined ? '' : documentStatus}&salespoolid=${salespool === undefined ? '' : salespool}&orderSequence=${documentType === undefined ? '' : documentType}`
      )
      .then(({ data }) => {
        if (data.success) {
          setOrderList(data.records.data);
          setFilteredData(data.records.data);
          setLoading(false);

          setTotal(data.records.total);
          setRowsPerPage(parseInt(data.records.per_page));
          setPage(data.records.current_page);
          setFrom(data.records.from);
          setLastPage(data.records.last_page);
          setTo(data.records.to);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoading(false);
        }
        setLoading(false);
      });
  };

  const handleOrderChangeRows = (e) => {
    setRowsPerPage(+e.target.value);
    localStorage.setItem("configRowPerPage", e.target.value);

    setLoading(true);
    httpclient
      .get(
        `getSalesOrders?version=v2&warehouseID=${id}&isPrinted=1&isPicked=0&page=${1}&per_page=${+e.target.value
        }&direction=asc&custaccount=${customerDetails.name === undefined ? '' : customerDetails.name
        }&sab_infocodeinformation=${schoolData.id === undefined ? '' : schoolData.id
        }&dlvmode=${deliveryType === undefined ? '' : deliveryType}&document_status=${documentStatus === undefined ? '' : documentStatus}&salespoolid=${salespool === undefined ? '' : salespool}&orderSequence=${documentType === undefined ? '' : documentType}`
      )
      .then(({ data }) => {
        if (data.success) {
          setOrderList(data.records.data);
          setFilteredData(data.records.data);
          setLoading(false);

          setTotal(data.records.total);
          setRowsPerPage(parseInt(data.records.per_page));
          setPage(data.records.current_page);
          setFrom(data.records.from);
          setLastPage(data.records.last_page);

          setLastPage(data.records.last_page);
          setTo(data.records.to);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoading(false);
        }
        setLoading(false);
      });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const handleChangeSearch = (e) => {
    if (e.target.value === "") {
      getOrderList();
    }
    setSearchText(e.target.value);
  };

  const handleSearch = (e) => {

    httpclient
      .get(
        `getSalesOrders?version=v2&warehouseID=${id}&isPrinted=1&isPicked=0&keyword=${searchText}`
      )
      .then(({ data }) => {
        if (data.success) {
          setOrderList(data.records.data);
          setFilteredData(data.records.data);
          setLoading(false);

          setTotal(data.records.total);
          setRowsPerPage(parseInt(data.records.per_page));
          setPage(data.records.current_page);
          setFrom(data.records.from);
          setLastPage(data.records.last_page);

          setLastPage(data.records.last_page);
          setTo(data.records.to);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoading(false);
        }
        setLoading(false);
      });
  };
  //Warehouse or Instore Order tab

  //express order tab 6 &isPrinted=1&isPicked=0
  const getExpressOrders = () => {
    setLoading(true);
    setLoadingToPrint(true);
    httpclient
      .get(
        `getSalesOrders?version=v2&warehouseID=${id}&${props.expressIndex === "to_pick_printed_orders"
          ? "isPrinted=1&isPicked=0"
          : "isPrinted=0"
        }&document_status=${documentStatus === undefined ? '' : documentStatus}`
      )
      .then(({ data }) => {
        if (data.success) {
          if (props.expressIndex === "to_pick_order_to_be_printed") {
            setExpressList(data.records.data);
            setLoadingToPrint(false);
            setFilteredData3(data.records.data);

            setTotalExpress(data.records.total);
            setRowsPerPageExpress(parseInt(data.records.per_page));
            setPageExpress(data.records.current_page);
            setFromExpress(data.records.from);
            setLastPageExpress(data.records.last_page);

            setToExpress(data.records.to);

          } else if (props.expressIndex === "to_pick_printed_orders") {

            setOrderList(data.records.data);
            setFilteredData(data.records.data);
            setLoading(false);
            setTotal(data.records.total);
            setRowsPerPage(parseInt(data.records.per_page));
            setPage(data.records.current_page);
            setFrom(data.records.from);
            setLastPage(data.records.last_page);
            setTo(data.records.to);

          }

          setCurrOrderNumbers(0);
          setBackdropNumber(5);
        } else {
          setLoading(false);
          setLoadingToPrint(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoading(false);
          setLoadingToPrint(false);
        }
        setLoading(false);
        setLoadingToPrint(false);
      });
  };

  const handleExpressPage = (e, page) => {
    setLoadingToPrint(true);
    setLoading(true);
    httpclient
      .get(
        `getSalesOrders?version=v2&warehouseID=${id}&${props.expressIndex === "to_pick_printed_orders"
          ? "isPrinted=1&isPicked=0"
          : "isPrinted=0"
        }&page=${page}&per_page=${rowsPerPageExpress}&keyword=${searchText3}&direction=asc&custaccount=${customerDetails.name === undefined ? '' : customerDetails.name
        }&sab_infocodeinformation=${schoolData.id === undefined ? '' : schoolData.id
        }&dlvmode=${deliveryType === undefined ? '' : deliveryType}&document_status=${documentStatus === undefined ? '' : documentStatus}&salespoolid=${salespool === undefined ? '' : salespool}&${(props.index === "to_pick" && fullfillPercentage !== '') ? `fulfillable_percentage=${fullfillPercentage === undefined ? '' : fullfillPercentage}` : ''}&orderSequence=${documentType === undefined ? '' : documentType}`
      )
      .then(({ data }) => {
        if (data.success) {
          if (props.expressIndex === "to_pick_order_to_be_printed") {
            setExpressList(data.records.data);
            setLoadingToPrint(false);
            setFilteredData3(data.records.data);

            setTotalExpress(data.records.total);
            setRowsPerPageExpress(parseInt(data.records.per_page));
            setPageExpress(data.records.current_page);
            setFromExpress(data.records.from);
            setLastPageExpress(data.records.last_page);

            setToExpress(data.records.to);

          } else if (props.expressIndex === "to_pick_printed_orders") {

            setOrderList(data.records.data);
            setFilteredData(data.records.data);
            setLoading(false);
            setTotal(data.records.total);
            setRowsPerPage(parseInt(data.records.per_page));
            setPage(data.records.current_page);
            setFrom(data.records.from);
            setLastPage(data.records.last_page);
            setTo(data.records.to);

          }

        } else {
          setLoading(false);
          setLoadingToPrint(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoading(false);
          setLoadingToPrint(false);
        }
        setLoading(false);
        setLoadingToPrint(false);
      });
  };

  const handleExpressRows = (e) => {
    setRowsPerPageExpress(+e.target.value);
    localStorage.setItem("configRowPerPage", e.target.value);
    setLoadingToPrint(true);
    setLoading(true);
    httpclient
      .get(
        `getSalesOrders?version=v2&warehouseID=${id}&${props.expressIndex === "to_pick_printed_orders"
          ? "isPrinted=1&isPicked=0"
          : "isPrinted=0"
        }&page=${1}&per_page=${+e.target.value
        }&direction=asc&custaccount=${customerDetails.name === undefined ? '' : customerDetails.name
        }&sab_infocodeinformation=${schoolData.id === undefined ? '' : schoolData.id
        }&dlvmode=${deliveryType === undefined ? '' : deliveryType}&document_status=${documentStatus === undefined ? '' : documentStatus}&salespoolid=${salespool === undefined ? '' : salespool}&${(props.index === "to_pick" && fullfillPercentage !== '') ? `fulfillable_percentage=${fullfillPercentage === undefined ? '' : fullfillPercentage}` : ''}&orderSequence=${documentType === undefined ? '' : documentType}`
      )
      .then(({ data }) => {
        if (data.success) {
          if (props.expressIndex === "to_pick_order_to_be_printed") {
            setExpressList(data.records.data);
            setLoadingToPrint(false);
            setFilteredData3(data.records.data);

            setTotalExpress(data.records.total);
            setRowsPerPageExpress(parseInt(data.records.per_page));
            setPageExpress(data.records.current_page);
            setFromExpress(data.records.from);
            setLastPageExpress(data.records.last_page);

            setToExpress(data.records.to);

          } else if (props.expressIndex === "to_pick_printed_orders") {

            setOrderList(data.records.data);
            setFilteredData(data.records.data);
            setLoading(false);
            setTotal(data.records.total);
            setRowsPerPage(parseInt(data.records.per_page));
            setPage(data.records.current_page);
            setFrom(data.records.from);
            setLastPage(data.records.last_page);
            setTo(data.records.to);

          }

        } else {
          setLoading(false);
          setLoadingToPrint(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoading(false);
          setLoadingToPrint(false);
        }
        setLoading(false);
        setLoadingToPrint(false);
      });
  };

  //express search
  const handleKeyDownExpress = (e) => {
    if (e.key === "Enter") {
      handleSearchExpress();
    }
  };

  const handleChangeSearchExpress = (e) => {
    if (e.target.value === "") {
      getExpressOrders();
    }
    setSearchText3(e.target.value);
  };

  const handleSearchExpress = (e) => {
    httpclient
      .get(
        `getSalesOrders?version=v2&warehouseID=${id}&keyword=${searchText3}&isPrinted=${0}`
      )
      .then(({ data }) => {
        if (data.success) {
          setExpressList(data.records.data);
          setLoading(false);
          setFilteredData3(data.records.data);

          setTotalExpress(data.records.total);
          setRowsPerPageExpress(parseInt(data.records.per_page));
          setPageExpress(data.records.current_page);
          setFromExpress(data.records.from);
          setLastPageExpress(data.records.last_page);

          setToExpress(data.records.to);
        } else {
          setLoading(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoading(false);
        }
        setLoading(false);
      });
  };



  //express search

  //express order tab

  const handleFilter = () => {
    setLoading(true);
    setLoadingToPrint(true);
    setLoadingToPick(true);
    httpclient
      .get(
        `getSalesOrders?version=v2&warehouseID=${id}
         ${props.index !== "ready_to_be_picked" && props.index !== "picked" ? `&isPrinted=${props.index === "to_pick" &&
          props.expressIndex === "to_pick_printed_orders" ? "1" : "0"}` : ''}
         ${props.index === "to_pick" ? props.expressIndex === "to_pick_printed_orders" ? `&isPicked=0` : '' :
          props.index === "ready_to_be_picked" ? `&isReadyForCollection=1` : ''}${props.index === "ready_to_be_picked" ? `&isPicked=0` : ''}${props.index === "picked" ? `&isPicked=1` : ''}${props.index === "picked" ? `&isReadyForCollection=1` : ''}
         &page=${page}&per_page=${rowsPerPageExpress}&direction=asc&custaccount=${customerDetails.name === undefined ? '' : customerDetails.name
         }&sab_infocodeinformation=${schoolData.id === undefined ? '' : schoolData.id
         }&dlvmode=${deliveryType === undefined ? '' : deliveryType}&document_status=${documentStatus === undefined ? '' : documentStatus}&salespoolid=${salespool === undefined ? '' : salespool}${props.index === "to_pick" && fullfillPercentage !== '' ? `&fulfillable_percentage=${fullfillPercentage === undefined ? '' : fullfillPercentage}` : ''}&orderSequence=${documentType === undefined ? '' : documentType}`
      )
      .then(({ data }) => {
        if (data.success) {

          if (props.index === "to_pick") {
            if (props.expressIndex === "to_pick_order_to_be_printed") {
              setExpressList(data.records.data);
              setLoadingToPrint(false);
              setFilteredData3(data.records.data);

              setTotalExpress(data.records.total);
              setRowsPerPageExpress(parseInt(data.records.per_page));
              setPageExpress(data.records.current_page);
              setFromExpress(data.records.from);
              setLastPageExpress(data.records.last_page);

              setToExpress(data.records.to);

            } else if (props.expressIndex === "to_pick_printed_orders") {

              setOrderList(data.records.data);
              setFilteredData(data.records.data);
              setLoading(false);
              setTotal(data.records.total);
              setRowsPerPage(parseInt(data.records.per_page));
              setPage(data.records.current_page);
              setFrom(data.records.from);
              setLastPage(data.records.last_page);
              setTo(data.records.to);

            }

          }

          else if (props.index === "to_prepare") {
            setOrderList(data.records.data);
            setFilteredData(data.records.data);
            setLoading(false);
            setTotal(data.records.total);
            setRowsPerPage(parseInt(data.records.per_page));
            setPage(data.records.current_page);
            setFrom(data.records.from);
            setLastPage(data.records.last_page);
            setLastPage(data.records.last_page);
            setTo(data.records.to);

          }

          else if (props.index === "ready_to_be_picked") {
            setReadyPickedList(data.records.data);
            setLoadingToPick(false);
            setFilteredDataPicked(data.records.data);
            setTotalPicked(data.records.total);
            setRowsPerPagePicked(parseInt(data.records.per_page));
            setPagePicked(data.records.current_page);
            setFromPicked(data.records.from);
            setLastPagePicked(data.records.last_page);
            setToPicked(data.records.to);

          }
          else if (props.index === "picked") {
            setPickedList(data.records.data);
            setLoadingToPick1(false);
            setFilteredDataPicked1(data.records.data);
            setTotalPicked1(data.records.total);
            setRowsPerPagePicked1(parseInt(data.records.per_page));
            setPagePicked1(data.records.current_page);
            setFromPicked1(data.records.from);
            setLastPagePicked1(data.records.last_page);
            setToPicked1(data.records.to);

          }
        } else {
          setLoading(false);
          setLoadingToPrint(false);
          setLoadingToPick(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoading(false);
          setLoadingToPrint(false);
          setLoadingToPick(false);
        }
        setLoading(false);
        setLoadingToPrint(false);
        setLoadingToPick(false);
      });
  };


  const handleFilterNotification = () => {
    setLoadingNots(true);
    const api = notificationType === "sms" ? `getSMS?warehouseID=${id}&keyword=${searchNotification}&custaccount=${customerDetails.name === undefined ? '' : customerDetails.name
    }&sab_infocodeinformation=${schoolData.id === undefined ? '' : schoolData.id
    }&dlvmode=${deliveryType === undefined ? '' : deliveryType}&document_status=${documentStatus === undefined ? '' : documentStatus}&salespoolid=${salespool === undefined ? '' : salespool}&orderSequence=${documentType === undefined ? '' : documentType}`
      :
      `getEmail?warehouseID=${id}&keyword=${searchNotification}&custaccount=${customerDetails.name === undefined ? '' : customerDetails.name
      }&sab_infocodeinformation=${schoolData.id === undefined ? '' : schoolData.id
      }&dlvmode=${deliveryType === undefined ? '' : deliveryType}&document_status=${documentStatus === undefined ? '' : documentStatus}&salespoolid=${salespool === undefined ? '' : salespool}&orderSequence=${documentType === undefined ? '' : documentType}`
    httpclient
      .get(api)
      .then(({ data }) => {
        if (data.success) {
          if (notificationType === "email") {
            setNotificationList(data.records.data);
            setLoadingNots(false);
            setFilteredData4(data.records.data);
            setTotalNots(data.records.total);
            setRowsPerPageNots(parseInt(data.records.per_page));
            setPageNots(data.records.current_page);
            setFromNots(data.records.from);
            setLastPageNots(data.records.last_page);
            setToNots(data.records.to);
          }
          else if (notificationType === "sms") {
            setNotificationListSMS(data.records.data);
            setLoadingNots(false);
            setFilteredData4SMS(data.records.data);
            setTotalNotsSMS(data.records.total);
            setRowsPerPageNotsSMS(parseInt(data.records.per_page));
            setPageNotsSMS(data.records.current_page);
            setFromNotsSMS(data.records.from);
            setLastPageNotsSMS(data.records.last_page);
            setToNotsSMS(data.records.to);
          }
        } else {
          setLoadingNots(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoadingNots(false);
        }
        setLoadingNots(false);
      });
  };

  const handleFilterInvoiced = () => {
    setLoadingInvoiced(true);
    httpclient
      .get(
        `getInvoicedOrder?warehouseID=${id
        }&keyword=${searchTextInvoiced}&custaccount=${customerDetails.name === undefined ? '' : customerDetails.name
        }&sab_infocodeinformation=${schoolData.id === undefined ? '' : schoolData.id
        }&dlvmode=${deliveryType === undefined ? '' : deliveryType}&document_status=${documentStatus === undefined ? '' : documentStatus}&salespoolid=${salespool === undefined ? '' : salespool}&${(props.index === "to_pick" && fullfillPercentage !== '') ? `fulfillable_percentage=${fullfillPercentage === undefined ? '' : fullfillPercentage}` : ''}&orderSequence=${documentType === undefined ? '' : documentType}`
      )
      .then(({ data }) => {
        if (data.success) {
          setLoadingInvoiced(false);
          setFilteredDataInvoiced(data.records.data);
          setTotalInvoiced(data.records.total);
          setRowsPerPageInvoiced(parseInt(data.records.per_page));
          setPageInvoiced(data.records.current_page);
          setFromInvoiced(data.records.from);
          setLastPageInvoiced(data.records.last_page);
          setToInvoiced(data.records.to);


          setCurrOrderNumbers(0);
          setBackdropNumber(5);
        } else {
          setLoadingInvoiced(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoadingInvoiced(false);
        }
        setLoadingInvoiced(false);
      });
  };


  const handleResetFilter = () => {


    setDeliveryType("");
    setDocumentType("");
    setSalesPool("");
    setDocumentStatus("");
    setfulfillPercentage("");
    setCustomerDetails({
      ...customerDetails,
      name: "",
    });
    setSchoolData({
      ...schoolData,
      name: "",
      id: "",
    });


  }



  const handleResetSearch = () => {

    setSearchNotification("");
    setSearchText("");
    setSearchText2("");
    setSearchText3("");
    setSearchText4("");
    setSearchTextPicked("");
    setSearchTextPicked1("");
    setSearchTextInvoiced("");
  }

  //notification tab
  const getNotificationLists = () => {
    setLoadingNots(true);
    const api = notificationType === "sms" ? `getSMS?warehouseID=${id}` : `getEmail?warehouseID=${id}`
    httpclient
      .get(api)
      .then(({ data }) => {
        if (data.success) {
          if (notificationType === "email") {
            setNotificationList(data.records.data);
            setLoadingNots(false);
            setFilteredData4(data.records.data);
            setTotalNots(data.records.total);
            setRowsPerPageNots(parseInt(data.records.per_page));
            setPageNots(data.records.current_page);
            setFromNots(data.records.from);
            setLastPageNots(data.records.last_page);
            setToNots(data.records.to);
          }
          else if (notificationType === "sms") {
            setNotificationListSMS(data.records.data);
            setLoadingNots(false);
            setFilteredData4SMS(data.records.data);
            setTotalNotsSMS(data.records.total);
            setRowsPerPageNotsSMS(parseInt(data.records.per_page));
            setPageNotsSMS(data.records.current_page);
            setFromNotsSMS(data.records.from);
            setLastPageNotsSMS(data.records.last_page);
            setToNotsSMS(data.records.to);
          }
        } else {
          setLoadingNots(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoadingNots(false);
        }
        setLoadingNots(false);
      });
  };



  const handleChangeNotificationPage = (e, page) => {
    setLoadingNots(true);
    const api = notificationType === "sms" ? `getSMS?warehouseID=${id}&page=${page}&per_page=${rowsPerPage}&keyword=${searchNotification}&custaccount=${customerDetails.name === undefined ? '' : customerDetails.name
    }&sab_infocodeinformation=${schoolData.id === undefined ? '' : schoolData.id
    }&dlvmode=${deliveryType === undefined ? '' : deliveryType}&document_status=${documentStatus === undefined ? '' : documentStatus}&salespoolid=${salespool === undefined ? '' : salespool}&orderSequence=${documentType === undefined ? '' : documentType}`
      :
      `getEmail?warehouseID=${id}&page=${page}&per_page=${rowsPerPage}&keyword=${searchNotification}&custaccount=${customerDetails.name === undefined ? '' : customerDetails.name
      }&sab_infocodeinformation=${schoolData.id === undefined ? '' : schoolData.id
      }&dlvmode=${deliveryType === undefined ? '' : deliveryType}&document_status=${documentStatus === undefined ? '' : documentStatus}&salespoolid=${salespool === undefined ? '' : salespool}&orderSequence=${documentType === undefined ? '' : documentType}`
    httpclient
      .get(api)
      .then(({ data }) => {
        if (data.success) {
          if (notificationType === "email") {
            setNotificationList(data.records.data);
            setLoadingNots(false);
            setFilteredData4(data.records.data);
            setTotalNots(data.records.total);
            setRowsPerPageNots(parseInt(data.records.per_page));
            setPageNots(data.records.current_page);
            setFromNots(data.records.from);
            setLastPageNots(data.records.last_page);
            setToNots(data.records.to);
          }
          else if (notificationType === "sms") {
            setNotificationListSMS(data.records.data);
            setLoadingNots(false);
            setFilteredData4SMS(data.records.data);
            setTotalNotsSMS(data.records.total);
            setRowsPerPageNotsSMS(parseInt(data.records.per_page));
            setPageNotsSMS(data.records.current_page);
            setFromNotsSMS(data.records.from);
            setLastPageNotsSMS(data.records.last_page);
            setToNotsSMS(data.records.to);
          }
        } else {
          setLoadingNots(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoadingNots(false);
        }
        setLoadingNots(false);
      });
  };

  const handleNotificationRows = (e) => {
    setRowsPerPage(e.target.value);
    localStorage.setItem("configRowPerPage", e.target.value);

    setLoadingNots(true);
    const api = notificationType === "sms" ? `getSMS?warehouseID=${id}&page=${1}&per_page=${e.target.value}&keyword=${searchNotification}&custaccount=${customerDetails.name === undefined ? '' : customerDetails.name
    }&sab_infocodeinformation=${schoolData.id === undefined ? '' : schoolData.id
    }&dlvmode=${deliveryType === undefined ? '' : deliveryType}&document_status=${documentStatus === undefined ? '' : documentStatus}&salespoolid=${salespool === undefined ? '' : salespool}&orderSequence=${documentType === undefined ? '' : documentType}`
      :
      `getEmail?warehouseID=${id}&page=${1}&per_page=${e.target.value}&keyword=${searchNotification}&custaccount=${customerDetails.name === undefined ? '' : customerDetails.name
      }&sab_infocodeinformation=${schoolData.id === undefined ? '' : schoolData.id
      }&dlvmode=${deliveryType === undefined ? '' : deliveryType}&document_status=${documentStatus === undefined ? '' : documentStatus}&salespoolid=${salespool === undefined ? '' : salespool}&orderSequence=${documentType === undefined ? '' : documentType}`
    httpclient
      .get(api)
      .then(({ data }) => {
        if (data.success) {
          if (notificationType === "email") {
            setNotificationList(data.records.data);
            setLoadingNots(false);
            setFilteredData4(data.records.data);
            setTotalNots(data.records.total);
            setRowsPerPageNots(parseInt(data.records.per_page));
            setPageNots(data.records.current_page);
            setFromNots(data.records.from);
            setLastPageNots(data.records.last_page);
            setToNots(data.records.to);
          }
          else if (notificationType === "sms") {
            setNotificationListSMS(data.records.data);
            setLoadingNots(false);
            setFilteredData4SMS(data.records.data);
            setTotalNotsSMS(data.records.total);
            setRowsPerPageNotsSMS(parseInt(data.records.per_page));
            setPageNotsSMS(data.records.current_page);
            setFromNotsSMS(data.records.from);
            setLastPageNotsSMS(data.records.last_page);
            setToNotsSMS(data.records.to);
          }
        } else {
          setLoadingNots(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoadingNots(false);
        }
        setLoadingNots(false);
      });
  };

  const handleKeyDownNotification = (e) => {
    if (e.key === "Enter") {
      handleSearchNotification();
    }
  };

  const handleSearchNotification = (e) => {
    setSearchNotification(e.target.value);
    // var searchValue = e.target.value;

    // var filtered = notificationList.filter((order) => {
    //   var orderNum = order.number;
    //   var toEmail = order.toEmail;
    //   var fromEmail = order.fromEmail;
    //   return (
    //     toEmail.toLowerCase().match(new RegExp(searchValue, "g")) ||
    //     fromEmail.toString().match(new RegExp(searchValue, "g")) ||
    //     orderNum.toString().match(new RegExp(searchValue, "g"))
    //   );
    // });

    // setFilteredData4(filtered);
  };

  //invoice tab
  const getInvoicedLists = () => {
    setLoadingInvoiced(true);
    httpclient
      .get(
        `getInvoicedOrder?warehouseID=${id}`
      )
      .then(({ data }) => {
        if (data.success) {
          setLoadingInvoiced(false);
          setFilteredDataInvoiced(data.records.data);
          setTotalInvoiced(data.records.total);
          setRowsPerPageInvoiced(parseInt(data.records.per_page));
          setPageInvoiced(data.records.current_page);
          setFromInvoiced(data.records.from);
          setLastPageInvoiced(data.records.last_page);
          setToInvoiced(data.records.to);


          setCurrOrderNumbers(0);
          setBackdropNumber(5);
        } else {
          setLoadingInvoiced(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoadingInvoiced(false);
        }
        setLoadingInvoiced(false);
      });
  };

  const handleChangeInvoicedPage = (e, page) => {
    setLoadingInvoiced(true);
    httpclient
      .get(
        `getInvoicedOrder?warehouseID=${id
        }&page=${page}&per_page=${rowsPerPageExpress}&keyword=${searchTextInvoiced}&direction=asc&custaccount=${customerDetails.name === undefined ? '' : customerDetails.name
        }&sab_infocodeinformation=${schoolData.id === undefined ? '' : schoolData.id
        }&dlvmode=${deliveryType === undefined ? '' : deliveryType}&document_status=${documentStatus === undefined ? '' : documentStatus}&salespoolid=${salespool === undefined ? '' : salespool}&${(props.index === "to_pick" && fullfillPercentage !== '') ? `fulfillable_percentage=${fullfillPercentage === undefined ? '' : fullfillPercentage}` : ''}&orderSequence=${documentType === undefined ? '' : documentType}`
      )
      .then(({ data }) => {
        if (data.success) {
          setLoadingInvoiced(false);
          setFilteredDataInvoiced(data.records.data);
          setTotalInvoiced(data.records.total);
          setRowsPerPageInvoiced(parseInt(data.records.per_page));
          setPageInvoiced(data.records.current_page);
          setFromInvoiced(data.records.from);
          setLastPageInvoiced(data.records.last_page);
          setToInvoiced(data.records.to);


          setCurrOrderNumbers(0);
          setBackdropNumber(5);
        } else {
          setLoadingInvoiced(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoadingInvoiced(false);
        }
        setLoadingInvoiced(false);
      });
  };

  const handleChangeInvoicedRows = (e) => {
    setRowsPerPageInvoiced(+e.target.value);
    localStorage.setItem("configRowPerPage", e.target.value);
    setLoadingInvoiced(true);
    httpclient
      .get(
        `getInvoicedOrder?warehouseID=${id
        }&page=${1}&per_page=${+e.target.value}&keyword=${searchTextInvoiced
        }&direction=asc&custaccount=${customerDetails.name === undefined ? '' : customerDetails.name
        }&sab_infocodeinformation=${schoolData.id === undefined ? '' : schoolData.id
        }&dlvmode=${deliveryType === undefined ? '' : deliveryType}&document_status=${documentStatus === undefined ? '' : documentStatus}&salespoolid=${salespool === undefined ? '' : salespool}&${(props.index === "to_pick" && fullfillPercentage !== '') ? `fulfillable_percentage=${fullfillPercentage === undefined ? '' : fullfillPercentage}` : ''}&orderSequence=${documentType === undefined ? '' : documentType}`
      )
      .then(({ data }) => {
        if (data.success) {
          setLoadingInvoiced(false);
          setFilteredDataInvoiced(data.records.data);
          setTotalInvoiced(data.records.total);
          setRowsPerPageInvoiced(parseInt(data.records.per_page));
          setPageInvoiced(data.records.current_page);
          setFromInvoiced(data.records.from);
          setLastPageInvoiced(data.records.last_page);
          setToInvoiced(data.records.to);


          setCurrOrderNumbers(0);
          setBackdropNumber(5);
        } else {
          setLoadingInvoiced(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoadingInvoiced(false);
        }
        setLoadingInvoiced(false);
      });
  };

  //invoiced search
  const handleKeyDownInvoiced = (e) => {
    if (e.key === "Enter") {
      handleSearchInvoiced();
    }
  };

  const handleChangeSearchInvoiced = (e) => {
    if (e.target.value === "") {
      getInvoicedLists();
    }
    setSearchTextInvoiced(e.target.value);
  };

  const handleSearchInvoiced = (e) => {
    httpclient
      .get(
        `getInvoicedOrder?warehouseID=${id}&keyword=${searchTextInvoiced}`
      )
      .then(({ data }) => {
        if (data.success) {
          setLoadingInvoiced(false);
          setFilteredDataInvoiced(data.records.data);
          setTotalInvoiced(data.records.total);
          setRowsPerPageInvoiced(parseInt(data.records.per_page));
          setPageInvoiced(data.records.current_page);
          setFromInvoiced(data.records.from);
          setLastPageInvoiced(data.records.last_page);
          setToInvoiced(data.records.to);


          setCurrOrderNumbers(0);
          setBackdropNumber(5);
        } else {
          setLoadingInvoiced(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoadingInvoiced(false);
        }
        setLoadingInvoiced(false);
      });
  };


  //invoice search

  //invoice order tab

  const handleViewMessage = (row) => {
    setOpenNotification(true);
    setNotificationDetails(row);
  };

  const sendNotificationDetail = (call) => {
    if (call.open === false) {
      setOpenNotification(false);
      setNotificationDetails({});
    }
  };

  const handleResendMessage = (row) => {
    if (window.confirm(`Are you sure you resend the ${notificationType}`)) {
      const api = notificationType === "sms" ? `resendSMS?id=${row.id}` : `resendEmail?id=${row.id}`
      httpclient(api).then(({ data }) => {
        if (data.success) {
          setOpen(true);
          setSnackStatus("success");
          setSnackMessage(data.message);
          setTimeout(() => {
            getNotificationLists();
          }, 1000);
        } else {
          setOpen(true);
          setSnackStatus("error");
          setSnackMessage(data.message);
        }
      });
    }
  };

  const handleResendInvoice = (row) => {
    console.log("resend inv", row);
    if (
      window.confirm(
        "Are you sure you want to resend tax invoice?"
      )
    ) {
      httpclient(`re-sent-invoice-attachment-email?id=${row.id}`).then(({ data }) => {
        if (data.success) {
          setOpen(true);
          setSnackStatus("success");
          setSnackMessage(data.message);
          setTimeout(() => {
            getInvoicedLists();
          }, 1000);
        } else {
          setOpen(true);
          setSnackStatus("error");
          setSnackMessage(data.message);
        }
      });

    }
  };

  const handleViewHistory = (row) => {
    setOpenHistoryDialog(true);
    setHistoryDetails(row);
  };

  const sendHistoryCallback = (call) => {
    if (call.open === false) {
      setOpenHistoryDialog(false);
      setHistoryDetails("");
    }
  };
  //notification tab

  //ready for Collection tab
  const getReadyToBePicked = () => {
    setLoadingToPick(true);
    httpclient
      .get(`getSalesOrders?version=v2&warehouseID=${id}&isReadyForCollection=1&isPicked=0`)
      .then(({ data }) => {
        if (data.success) {
          setReadyPickedList(data.records.data);
          setLoadingToPick(false);
          setFilteredDataPicked(data.records.data);

          setTotalPicked(data.records.total);
          setRowsPerPagePicked(parseInt(data.records.per_page));
          setPagePicked(data.records.current_page);
          setFromPicked(data.records.from);
          setLastPagePicked(data.records.last_page);

          setToPicked(data.records.to);
        } else {
          setLoadingToPick(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoadingToPick(false);
        }
        setLoadingToPick(false);
      });
  };

  const handleChangePickedPage = (e, page) => {
    setLoadingToPick(true);
    httpclient
      .get(
        `getSalesOrders?version=v2&warehouseID=${id}&isReadyForCollection=1&isPicked=0&page=${page}&per_page=${rowsPerPage}&custaccount=${customerDetails.name === undefined ? '' : customerDetails.name
        }&sab_infocodeinformation=${schoolData.id === undefined ? '' : schoolData.id
        }&dlvmode=${deliveryType === undefined ? '' : deliveryType}&document_status=${documentStatus === undefined ? '' : documentStatus}&salespoolid=${salespool === undefined ? '' : salespool}&orderSequence=${documentType === undefined ? '' : documentType}`
      )
      .then(({ data }) => {
        if (data.success) {
          setReadyPickedList(data.records.data);
          setLoadingToPick(false);
          setFilteredDataPicked(data.records.data);

          setTotalPicked(data.records.total);
          setRowsPerPagePicked(parseInt(data.records.per_page));
          setPagePicked(data.records.current_page);
          setFromPicked(data.records.from);
          setLastPagePicked(data.records.last_page);

          setToPicked(data.records.to);
        } else {
          setLoadingToPick(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {

          setLoadingToPick(false);
        }

        setLoadingToPick(false);
      });
  };

  const handleChangePickedRows = (e) => {
    setRowsPerPage(e.target.value);
    localStorage.setItem("configRowPerPage", e.target.value);

    setLoadingToPick(true);
    httpclient
      .get(
        `getSalesOrders?version=v2&warehouseID=${id}&isReadyForCollection=1&isPicked=0&page=${page}&per_page=${e.target.value}&keyword=${searchTextPicked}&custaccount=${customerDetails.name === undefined ? '' : customerDetails.name
        }&sab_infocodeinformation=${schoolData.id === undefined ? '' : schoolData.id
        }&dlvmode=${deliveryType === undefined ? '' : deliveryType}&document_status=${documentStatus === undefined ? '' : documentStatus}&salespoolid=${salespool === undefined ? '' : salespool}&orderSequence=${documentType === undefined ? '' : documentType}`
      )
      .then(({ data }) => {
        if (data.success) {
          setReadyPickedList(data.records.data);
          setLoadingToPick(false);
          setFilteredDataPicked(data.records.data);

          setTotalPicked(data.records.total);
          setRowsPerPagePicked(parseInt(data.records.per_page));
          setPagePicked(data.records.current_page);
          setFromPicked(data.records.from);
          setLastPagePicked(data.records.last_page);

          setToPicked(data.records.to);
        } else {
          setLoadingToPick(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoadingToPick(false);
        }
        setLoadingToPick(false);
      });
  };

  const handleKeyDownPicked = (e) => {
    if (e.key === "Enter") {
      handleSearchPicked();
    }
  };

  const handleChangeSearchPicked = (e) => {
    if (e.target.value === "") {
      getReadyToBePicked();
    }
    setSearchTextPicked(e.target.value);
  };

  const handleSearchPicked = (e) => {
    setLoadingToPick(true);
    httpclient
      .get(
        `getSalesOrders?version=v2&warehouseID=${id}&isReadyForCollection=1&isPicked=0&keyword=${searchTextPicked}&custaccount=${customerDetails.name === undefined ? '' : customerDetails.name
        }&sab_infocodeinformation=${schoolData.id === undefined ? '' : schoolData.id
        }&dlvmode=${deliveryType === undefined ? '' : deliveryType}&document_status=${documentStatus === undefined ? '' : documentStatus}&salespoolid=${salespool === undefined ? '' : salespool}&orderSequence=${documentType === undefined ? '' : documentType}`
      )
      .then(({ data }) => {
        if (data.success) {
          setReadyPickedList(data.records.data);
          setLoadingToPick(false);
          
          setFilteredDataPicked(data.records.data);

          setTotalPicked(data.records.total);
          setRowsPerPagePicked(parseInt(data.records.per_page));
          setPagePicked(data.records.current_page);
          setFromPicked(data.records.from);
          setLastPagePicked(data.records.last_page);

          setToPicked(data.records.to);
        } else {
          setLoadingToPick(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoadingToPick(false);
        }
        setLoadingToPick(false);
      });
  };

  const handleMarkPick = (order) => {
    if (
      window.confirm(
        "Are you sure you want the to mark the order as collected?"
      )
    ) {
      httpclient
        .get(`markAsPicked?warehouseID=${id}&salesDocumentIDs=${order.id}`)
        .then(({ data }) => {
          if (data.success) {
            setOpen(true);
            setSnackStatus("success");
            setSnackMessage(data.message);
            setTimeout(() => {
              getReadyToBePicked();
              getOrderCount();
              setCheckedValues([]);
              setMarkCheckValues([]);
              setSearchTextPicked("");
            }, 500);
          } else {
            setOpen(true);
            setSnackStatus("error");
            setSnackMessage(data.message);
          }
        });
    } else {
      setSearchTextPicked("");
      getReadyToBePicked();
    }
  };

  const handleMultipleMark = () => {
    let salesIDs = markCheckValues.join(",");

    if (
      window.confirm(
        "Are you sure you want the to mark the selected orders as picked?"
      )
    ) {
      httpclient
        .get(`markAsPicked?warehouseID=${id}&salesDocumentIDs=${salesIDs}`)
        .then(({ data }) => {
          if (data.success) {
            setOpen(true);
            setSnackStatus("success");
            setSnackMessage(data.message);
            setTimeout(() => {
              getReadyToBePicked();
              getOrderCount();
              setCheckedValues([]);
              setMarkCheckValues([]);
            }, 500);
          } else {
            setOpen(true);
            setSnackStatus("error");
            setSnackMessage(data.message);
          }
        });
    }
  };

  const handleMarkDialogue = () => {
    let salesIDs1 = markCheckValues.join(",");
    setSalesIDs(salesIDs1);
    setOpenMarkDialog(true);
  };

  const sendToMark = (call, detail) => {

    if (call.open === false) {
      setOpenMarkDialog(false);
    }
    if (call.success === true) {
      //setKeyLoading(true);
      httpclient
        .get(`markAsPicked?warehouseID=${id}&salesDocumentIDs=${salesIDs}&transCollectedRef=${detail}`)
        .then(({ data }) => {
          if (data.success) {
            setOpen(true);
            setSnackStatus("success");
            setSnackMessage(data.message);
            setTimeout(() => {
              getReadyToBePicked();
              getOrderCount();
              setCheckedValues([]);
              setMarkCheckValues([]);
            }, 500);
          } else {
            setOpen(true);
            setSnackStatus("error");
            setSnackMessage(data.message);
          }
        });
    }
  };

  const handleMarkDialogueOrder = (order) => {
    setOrderPick(order);
    setOpenMarkDialog(true);
  };

  const sendToMarkOrder = (order, call, detail) => {

    if (call.open === false) {
      setOpenMarkDialog(false);
    }
    if (call.success === true) {
      //setKeyLoading(true);
      httpclient
        .get(`markAsPicked?warehouseID=${id}&salesDocumentIDs=${order.id}&transCollectedRef=${detail}`)
        .then(({ data }) => {
          if (data.success) {
            setOpen(true);
            setSnackStatus("success");
            setSnackMessage(data.message);
            setTimeout(() => {
              setOrderPick({});
              getReadyToBePicked();
              getOrderCount();
              setCheckedValues([]);
              setMarkCheckValues([]);
            }, 500);
          } else {
            setOpen(true);
            setSnackStatus("error");
            setSnackMessage(data.message);
          }
        });
    }
  };

  //ready for Collection tab  

  //picked order tab


  //ready for Collection tab
  const getPicked = () => {
    setLoadingToPick1(true);
    httpclient
      .get(`getSalesOrders?version=v2&warehouseID=${id}&isReadyForCollection=1&isPicked=1`)
      .then(({ data }) => {
        if (data.success) {
          setPickedList(data.records.data);
          setLoadingToPick1(false);
          setFilteredDataPicked1(data.records.data);

          setTotalPicked1(data.records.total);
          setRowsPerPagePicked1(parseInt(data.records.per_page));
          setPagePicked1(data.records.current_page);
          setFromPicked1(data.records.from);
          setLastPagePicked1(data.records.last_page);

          setToPicked1(data.records.to);
        } else {
          setLoadingToPick1(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoadingToPick1(false);
        }
        setLoadingToPick1(false);
      });
  };

  const handleChangePickedPage1 = (e, page) => {
    setLoadingToPick1(true);
    httpclient
      .get(
        `getSalesOrders?version=v2&warehouseID=${id}&isReadyForCollection=1&isPicked=1&page=${page}&per_page=${rowsPerPage}&custaccount=${customerDetails.name === undefined ? '' : customerDetails.name
        }&sab_infocodeinformation=${schoolData.id === undefined ? '' : schoolData.id
        }&dlvmode=${deliveryType === undefined ? '' : deliveryType}&document_status=${documentStatus === undefined ? '' : documentStatus}&salespoolid=${salespool === undefined ? '' : salespool}&orderSequence=${documentType === undefined ? '' : documentType}`
      )
      .then(({ data }) => {
        if (data.success) {
          setPickedList(data.records.data);
          setLoadingToPick1(false);
          setFilteredDataPicked1(data.records.data);

          setTotalPicked1(data.records.total);
          setRowsPerPagePicked1(parseInt(data.records.per_page));
          setPagePicked1(data.records.current_page);
          setFromPicked1(data.records.from);
          setLastPagePicked1(data.records.last_page);

          setToPicked1(data.records.to);
        } else {
          setLoadingToPick1(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {

          setLoadingToPick1(false);
        }

        setLoadingToPick1(false);
      });
  };

  const handleChangePickedRows1 = (e) => {
    setRowsPerPage(e.target.value);
    localStorage.setItem("configRowPerPage", e.target.value);

    setLoadingToPick1(true);
    httpclient
      .get(
        `getSalesOrders?version=v2&warehouseID=${id}&isReadyForCollection=1&isPicked=1&page=${page}&per_page=${e.target.value}&keyword=${searchTextPicked}&custaccount=${customerDetails.name === undefined ? '' : customerDetails.name
        }&dlvmode=${deliveryType === undefined ? '' : deliveryType}&document_status=${documentStatus === undefined ? '' : documentStatus}&salespoolid=${salespool === undefined ? '' : salespool}&orderSequence=${documentType === undefined ? '' : documentType}`
      )
      .then(({ data }) => {
        if (data.success) {
          setPickedList(data.records.data);
          setLoadingToPick1(false);
          setFilteredDataPicked1(data.records.data);

          setTotalPicked1(data.records.total);
          setRowsPerPagePicked1(parseInt(data.records.per_page));
          setPagePicked1(data.records.current_page);
          setFromPicked1(data.records.from);
          setLastPagePicked1(data.records.last_page);

          setToPicked1(data.records.to);
        } else {
          setLoadingToPick1(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoadingToPick1(false);
        }
        setLoadingToPick1(false);
      });
  };

  const handleKeyDownPicked1 = (e) => {
    if (e.key === "Enter") {
      handleSearchPicked1();
    }
  };

  const handleChangeSearchPicked1 = (e) => {
    if (e.target.value === "") {
      getPicked();
    }
    setSearchTextPicked1(e.target.value);
  };

  const handleSearchPicked1 = (e) => {
    setLoadingToPick1(true);
    httpclient
      .get(
        `getSalesOrders?version=v2&warehouseID=${id}&isReadyForCollection=1&isPicked=1&keyword=${searchTextPicked1}`
      )
      .then(({ data }) => {
        if (data.success) {
          setPickedList(data.records.data);
          setLoadingToPick1(false);
          setFilteredDataPicked1(data.records.data);

          setTotalPicked1(data.records.total);
          setRowsPerPagePicked1(parseInt(data.records.per_page));
          setPagePicked1(data.records.current_page);
          setFromPicked1(data.records.from);
          setLastPagePicked1(data.records.last_page);

          setToPicked1(data.records.to);
        } else {
          setLoadingToPick1(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoadingToPick1(false);
        }
        setLoadingToPick1(false);
      });
  };



  //

  // const handleRefetch = () => {
  //   if (props.index === "express") {
  //     getExpressOrders();
  //   }

  //   if (props.index === "instore") {
  //     getOrderList();
  //   }

  //   setTimeout(() => {
  //     setCurrOrderNumbers(0);
  //   }, 2000);
  // };

  // const getPickupList = () => {
  //   setLoading(true);
  //   httpclient
  //     .get(`wms/orders/lines?warehouseID=${id}`)
  //     .then(({ data }) => {
  //       if (data.success) {
  //         setPickupList(data.records);
  //         setLoading(false);
  //       }
  //     })
  //     .catch((e) => {
  //       if (e.status === 401) {
  //         setLoading(false);
  //       }
  //       setLoading(false);
  //     });
  // };

  const handlePickupOrder = (order) => {
    setPickupOrder(order);
    setOrderDetails(order);
    // setValue(2);

    navigate(`/warehouse_orders/orders/${id}/tab_pickup`);
  };


  const handlePickOrder = (order) => {

    setCheckedValues([order.id]);
    if (
      window.confirm(
        "Are you sure you want the to pick the order?"
      )
    ) {
      httpclient
        .get(`readyForCollection?warehouseID=${id}&salesDocumentIDs=${order.id}`)
        .then(({ data }) => {
          if (data.success) {
            setOpen(true);
            setSnackStatus("success");
            setSnackMessage(data.message);
            setTimeout(() => {
              getOrderList();
              getOrderCount();
              setCheckedValues([]);
              setMarkCheckValues([]);
            }, 500);
          } else {
            setOpen(true);
            setSnackStatus("error");
            setSnackMessage(data.message);
          }
        });
    }
  };

  const handleMultiplePick = (option, order) => {

    let salesIDs = checkedValues.join(",");
    if (
      window.confirm(
        "Are you sure you want the to pick these orders?"
      )
    ) {
      httpclient
        .get(`readyForCollection?warehouseID=${id}&salesDocumentIDs=${salesIDs}`)
        .then(({ data }) => {
          if (data.success) {
            setOpen(true);
            setSnackStatus("success");
            setSnackMessage(data.message);
            setTimeout(() => {
              getOrderList();
              getOrderCount();
              setCheckedValues([]);
              setMarkCheckValues([]);
            }, 500);
          } else {
            setOpen(true);
            setSnackStatus("error");
            setSnackMessage(data.message);
          }
        });
    }
  };


  const handleUnpickOrder = (order) => {

    setCheckedValues([order.id]);
    if (
      window.confirm(
        "Are you sure you want the to unpick the order?"
      )
    ) {
      httpclient
        .get(`printSalesOrder?warehouseID=${id}&salesDocumentIDs=${order.id}&isUnpickOrder=1`)
        .then(({ data }) => {
          if (data.success) {
            setOpen(true);
            setSnackStatus("success");
            setSnackMessage(data.message);
            setTimeout(() => {
              getOrderList();
              getOrderCount();
              setCheckedValues([]);
              setMarkCheckValues([]);
            }, 500);
          } else {
            setOpen(true);
            setSnackStatus("error");
            setSnackMessage(data.message);
          }
        });
    }
  };

  const handleMultipleUnpick = (option, order) => {

    let salesIDs = checkedValues.join(",");
    if (
      window.confirm(
        "Are you sure you want the to unpick these orders?"
      )
    ) {
      httpclient
        .get(`printSalesOrder?warehouseID=${id}&salesDocumentIDs=${salesIDs}&isUnpickOrder=1`)
        .then(({ data }) => {
          if (data.success) {
            setOpen(true);
            setSnackStatus("success");
            setSnackMessage(data.message);
            setTimeout(() => {
              getOrderList();
              getOrderCount();
              setCheckedValues([]);
              setMarkCheckValues([]);
            }, 500);
          } else {
            setOpen(true);
            setSnackStatus("error");
            setSnackMessage(data.message);
          }
        });
    }
  };


  const handlePrintTaxInvoice = (link) => {
    setPrintDetails(link);
    setShowPrintDialog(true);
  };

  const handleRePrintTaxInvoice = (order) => {
    setPrintDetails(`${GlobalURL[0].url}/generate-invoice-receipt?warehouseID=${id}&invoiceID=${order.id}`);
    setShowPrintDialog(true);
  };

  const handlePrint = (option, order) => {

    setCheckedValues([order.id]);
    setPrintDetails(
      `${GlobalURL[0].url}/printSalesOrder?warehouseID=${id}&salesDocumentIDs=${order.id
      }&size=${option === "Print" ? true : false}`
    );
    setShowPrintDialog(true);
  };

  const handlePrintNots = (option, order) => {

    setCheckedValues([order.order.id]);



    setPrintDetails(
      `${GlobalURL[0].url}/printSalesOrder?warehouseID=${id}&salesDocumentIDs=${order.order.id
      }&size=${option === "Print" ? true : false}&type=reprint`
    );
    setShowPrintDialog(true);
  };

  // console.log("pd", printDetails);

  useEffect(() => {
    let intervalId;
    let e;
    if (openBackdrop) {
      intervalId = setInterval(() => {
        setBackdropNumber((prevBackdropNumber) => {
          if (prevBackdropNumber > 1) {
            return prevBackdropNumber - 1;
          } else {
            clearInterval(intervalId);
            setOpenBackdrop(false);

            props.index !== "notification" && props.index === "to_pick" ? handleExpressPage(e, pageExpress) : getOrderList();
            getOrderCount();
            setCheckedValues([]);

            setTimeout(() => {
              return 5;
            }, 1000);
          }
        });
      }, 1000);
      return () => {
        // Clear the interval when the component unmounts
        clearInterval(intervalId);
      };
    }
  }, [openBackdrop === true]);

  const callbackPrintPreview = (call) => {
    if (call.open === false) {
      setShowPrintDialog(false);
      setPrintDetails("");
      // setCheckedValues([]);

      if (props.index === "to_pick" || props.index === "to_prepare" || props.index === "notification") {
        setOpenBackdrop(true);
      } else {
        setCheckedValues([]);
      }
    }
  };


  const handleOrderCodeFilter = (value) => {
    setOrderName(value);
    setLoadingPreparing(true);
    httpclient
      .get(`getSalesOrders?version=v2&warehouseID=${id}&isPrinted=1&isPicked=0&keyword=${value}`)
      .then(({ data }) => {
        if (data.success) {
          if (data.records.data.length > 0) {
            setPickupOrder(data.records.data[0]);
            setOrderDetails(data.records.data[0]);
            setTimeout(() => {
              setLoadingPreparing(false);
            }, 1000);
          } else {
            setOrderCode("");
            setOrderName("");
            setOpen(true);
            setSnackStatus("error");
            setSnackMessage("Order not found. Please re-enter your barcode.")
            setPickupOrder([]);
            setOrderDetails({});
            setTimeout(() => {
              setLoadingPreparing(false);
            }, 1000);

          }

        }
      });
  };

  const handleOrderFilter = (value) => {
    setOrderName(value !== null ? value.salesid : "");

    orderList.map((order) => {
      if (order.id === value.id) {
        setPickupOrder(order);
        setOrderDetails(order);
      }
    });
  };

  const handleChangeOrder = (e) => {
    setOrderName(e.target.value);
  };

  const handleView = (num) => {
    setView(num);
    localStorage.setItem("view", JSON.stringify(num));
  };

  const handleViewDetails = (order, check, print) => {
    setOpenViewDetails(true);
    setViewDetails(order);
    setCheck(check);
    setPrint(print);
  };

  const sendViewDetails = (call) => {
    if (call.open === false) {
      setOpenViewDetails(false);
      setViewDetails("");
    }
  };

  const handleViewHistoryDetails = (order) => {
    setOpenViewHistoryDetails(true);
    setViewHistoryDetails(order);

  };

  const sendViewHistoryDetails = (call) => {
    if (call.open === false) {
      setOpenViewHistoryDetails(false);
      setViewHistoryDetails("");
    }
  };

  //checked to print
  const handleCheck = (e, row) => {
    const newCheckedValues = [...checkedValues];
    const newMarkValues = [...markCheckValues];

    if (newCheckedValues.includes(row.id)) {
      if (e.target.checked === false) {
        var res = newCheckedValues.filter((che) => che !== row.id);
        var markRes = markCheckValues.filter((mark) => mark !== row.id);
        setCheckedValues(res);
        setMarkCheckValues(markRes);
      }
    } else {
      newCheckedValues.push(row.id);
      newMarkValues.push(row.id);
      setCheckedValues(newCheckedValues);
      setMarkCheckValues(newMarkValues);
    }
  };

  const handleCheckNots = (e, row) => {
    const newCheckedValues = [...checkedValues];
    const newMarkValues = [...markCheckValues];

    if (newCheckedValues.includes(row.order.id)) {
      if (e.target.checked === false) {
        var res = newCheckedValues.filter((che) => che !== row.order.id);
        var markRes = markCheckValues.filter((mark) => mark !== row.order.id);
        setCheckedValues(res);
        setMarkCheckValues(markRes);
      }
    } else {
      newCheckedValues.push(row.order.id);
      newMarkValues.push(row.order.id);
      setCheckedValues(newCheckedValues);
      setMarkCheckValues(newMarkValues);
    }
  };

  const handleMultiplePrint = (option, order) => {

    let salesIDs = checkedValues.join(",");
    setPrintDetails(
      `${GlobalURL[0].url}/printSalesOrder?warehouseID=${id}&salesDocumentIDs=${salesIDs}&size=${option === "Print" ? true : false
      }`
    );
    setShowPrintDialog(true);
  };

  const handleMultiplePrintNots = (option, order) => {

    let salesIDs = checkedValues.join(",");
    setPrintDetails(
      `${GlobalURL[0].url}/printSalesOrder?warehouseID=${id}&salesDocumentIDs=${salesIDs}&size=${option === "Print" ? true : false
      }&type=reprint`
    );
    setShowPrintDialog(true);
  };
  //checked to print

  //snackbar mui
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  //console.log("props.index", props.index);
  // console.log("props.expressindex", props.expressIndex);
  //console.log("document Status", documentStatus);
  return (
    <Container maxWidth="xl">
      <Box sx={{ width: "100%" }}>
        {featureServer && <Box textAlign={"right"} mb={2}><strong>Script Last Synced:</strong>{""} {moment(scriptLastSynced).format("ddd, MMM Do YYYY, h:mm a")}</Box>}

        <Box p={3}>
          <Grid container spacing={2}>
            <Grid item xs={isMobile ? 12 : 10}>
              <FlexContent>
                <FlexInnerTitle>
                  <span>Delivery Type</span>


                  <FormControl fullWidth size="small">
                    <Select
                      //value={}
                      onChange={handleDeliveryChange}
                      value={deliveryType}
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      <MenuItem value="">
                        <span></span>
                      </MenuItem>
                      {delivery.map((del) =>
                        <MenuItem value={del.dlvmode}>{del.dlvmode}</MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </FlexInnerTitle>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <FlexInnerTitle>
                  <span>Sales Type</span>


                  <FormControl fullWidth size="small">
                    <Select
                      //value={}
                      onChange={handleSalesChange}
                      value={documentType}
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                      style={getColorForOption(documentType)}
                    >
                      <MenuItem value=""></MenuItem>

                      <MenuItem value="1" style={getColorForOption("1")}>Parent Orders</MenuItem>
                      <MenuItem value="2" style={getColorForOption("2")}>Transfer Orders</MenuItem>
                      <MenuItem value="3" style={getColorForOption("3")}>Web Orders</MenuItem>
                      <MenuItem value="4" style={getColorForOption("4")}>Sales Orders</MenuItem>

                    </Select>
                  </FormControl>
                </FlexInnerTitle>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>

                {/* <FlexInnerTitle>
                  <span>Customer</span>



                  <FormControl fullWidth size="small">
                    <Autocomplete
                      disablePortal
                      inputValue={customerDetails.name}
                      //options={rows.length > 0 ? rows : []}
                      options={sortedOptions}
                      getOptionLabel={(option) => option.name || null}
                      renderOption={(props, option, index) => {
                        return (
                          <li {...props} key={option.id}>
                            {option.name}
                          </li>
                        );
                      }}
                      sx={{ width: "100%" }}
                      onChange={(event, newValue) => {
                        handleSearchFilter(newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          name="name"
                          value={customerDetails.name || ""}
                          onChange={handleChangeCustomer}
                        />
                      )}
                    />
                  </FormControl>
                </FlexInnerTitle> */}
                <FlexInnerTitle>
                  <span>School</span>



                  <FormControl fullWidth size="small">
                    <Autocomplete
                      disablePortal
                      inputValue={schoolData.name}
                      //options={rows.length > 0 ? rows : []}
                      options={sortedSchools}
                      getOptionLabel={(option) => option.SchoolName || []}
                      renderOption={(props, option, index) => {
                        return (
                          <li {...props} key={option.SchoolID}>
                            {option.SchoolName}
                          </li>
                        );
                      }}
                      sx={{ width: "100%" }}
                      onChange={(event, newValue) => {
                        handleSearchSchoolFilter(newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          name="name"
                          value={schoolData.name || ""}
                          onChange={handleChangeSchool}
                        />
                      )}
                    />
                  </FormControl>
                </FlexInnerTitle>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <FlexInnerTitle>
                  <span>Sales Pool</span>


                  <FormControl fullWidth size="small">
                    <Select
                      //value={}
                      onChange={handleSalesPoolChange}
                      value={salespool}
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      {/* <MenuItem value="">
                      <span></span>
                    </MenuItem> */}
                      {salesPoolID.map((sal) =>
                        <MenuItem value={sal.salespoolid}>{sal.salespoolid}</MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </FlexInnerTitle>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <FlexInnerTitle>
                  <span>Document Status </span>


                  <FormControl fullWidth size="small">
                    <Select
                      //value={}
                      sx={{ minWidth: "160px" }}
                      onChange={handleDocumentStatus}
                      value={documentStatus}
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      <MenuItem value=""></MenuItem>

                      <MenuItem value="Confirmation">Confirmation</MenuItem>
                      <MenuItem value="Tax Invoice">Tax Invoice</MenuItem>
                      <MenuItem value="None">None</MenuItem>

                    </Select>
                  </FormControl>
                </FlexInnerTitle>
              </FlexContent>

            </Grid>

            <Grid item xs={isMobile ? 12 : 2}>
              <Box textAlign="right">

                <Button
                  size="large"
                  variant="contained"
                  color="primary"
                  onClick={handleResetFilter}
                  sx={{
                    //borderRadius: "10px",
                    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",

                    //fontSize: "12px",
                  }}
                >
                  Reset Filter
                </Button>

              </Box>
            </Grid>
          </Grid>
          {/* <Grid container spacing={2}>
            <Grid item xs={isMobile ? 12 : 10}>
              <FlexContent>
                <FlexInnerTitle>
                  <span>Document Status </span>
                

                <FormControl size="small">
                  <Select
                    //value={}
                    sx={{ minWidth: "160px" }}
                    onChange={handleDocumentStatus}
                    value={documentStatus}
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                  >
                    <MenuItem value=""></MenuItem>

                    <MenuItem value="Confirmation">Confirmation</MenuItem>
                    <MenuItem value="Tax Invoice">Tax Invoice</MenuItem>
                    <MenuItem value="None">None</MenuItem>

                  </Select>
                </FormControl>
                </FlexInnerTitle>
              </FlexContent>
            </Grid>
          </Grid> */}

        </Box>
        <Box sx={{ borderBottom: 1, borderColor: "divider", display: 'flex', justifyContent: 'space-between' }}>
          <Tabs
            orientation={isMobile ? "vertical" : "horizontal"}
            value={props.index}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{ flexGrow: 1 }}
          >
            <Tab
              label={
                <span>
                  <span>{`To Be Picked`}</span>
                  <span className={toBePickedOrdersCount == "0" ? "" : "dark_text"}>
                    {` ( ${toBePickedOrdersCount} ) `}
                  </span>
                </span>
              }
              value="to_pick"
            />

            <Tab
              label={
                <span>
                  <span>{`Preparing Orders`}</span>
                  <span className={preparingOrdersCount == "0" ? "" : "dark_text"}>
                    {` ( ${preparingOrdersCount} ) `}
                  </span>
                </span>
              }
              value="pickup"
            />

            <Tab
              label={
                <span>
                  <span>{`Ready for Collection`}</span>
                  <span className={readyForCollectionOrdersCount == "0" ? "" : "dark_text"}>
                    {` ( ${readyForCollectionOrdersCount} ) `}
                  </span>
                </span>
              }
              value="ready_to_be_picked"
            />

            <Tab
              label={
                <span>
                  <span>{`Notifications`}</span>
                  <span className={notificationCount == "0" ? "" : "dark_text"}>
                    {` ( ${notificationCount} ) `}
                  </span>
                </span>
              }
              value="notification"
            />

            {featureServer && <Tab
              label={
                <span>
                  <span>{`Invoiced`}</span>
                  <span className={invoicedCount == "0" ? "" : "dark_text"}>
                    {` ( ${invoicedCount} ) `}
                  </span>
                </span>
              }
              value="invoiced"
            />}
          </Tabs>
          <Tabs
            orientation={isMobile ? "vertical" : "horizontal"}
            value={props.index}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
          >
            {/* Your last tab */}
            <Tab
              label={
                <span>
                  <span>{`Query History`}</span>
                  <span className={pickedOrdersCount == "0" ? "" : "dark_text"}>
                    {` ( ${pickedOrdersCount} ) `}
                  </span>
                </span>
              }
              value="picked"
            />
          </Tabs>
        </Box>


        {/* Express Orders */}
        <CustomTabPanel value={props.index} index={"to_pick"}>
          {props.expressIndex === "to_pick_order_to_be_printed" ? (
            <ToPickOrderComponent
              lastPageExpress={lastPageExpress}
              pageExpress={pageExpress}
              handleExpressPage={handleExpressPage}
              handlePickupOrder={handlePickupOrder}
              handlePrint={handlePrint}
              handleMultiplePrint={handleMultiplePrint}
              currOrderNumbers={currOrderNumbers}
              //handleRefetch={handleRefetch}
              handleFulfillChange={handleFulfillChange}
              fullfillPercentage={fullfillPercentage}
              handleView={handleView}
              handleKeyDownExpress={handleKeyDownExpress}
              handleChangeSearchExpress={handleChangeSearchExpress}
              searchText3={searchText3}
              isMobile={isMobile}
              loading={loadingToPrint}
              view={view}
              handleChangeExpressTab={handleChangeExpressTab}
              expressPrintedValue={expressPrintedValue}
              expressIndex={props.expressIndex}
              columns={columnsToPick}
              filteredData3={filteredData3}
              totalExpress={totalExpress}
              fromExpress={fromExpress}
              toExpress={toExpress}
              rowsPerPageExpress={rowsPerPageExpress}
              handleExpressRows={handleExpressRows}
              handleViewDetails={handleViewDetails}
              handleCheck={handleCheck}
              checkedValues={checkedValues}
              openBackdrop={openBackdrop}
              backdropNumber={backdropNumber}
            />
          ) : (
            <ToPickOrderComponent
              isMobile={isMobile}
              lastPageExpress={lastPage}
              pageExpress={page}
              handleExpressPage={handleOrderChangePage}
              filteredData3={filteredData}
              handlePrint={handlePrint}
              handlePickupOrder={handlePickupOrder}
              handlePickOrder={handlePickOrder}
              handleMultiplePick={handleMultiplePick}
              handleUnpickOrder={handleUnpickOrder}
              handleMultipleUnpick={handleMultipleUnpick}
              checkedValues={checkedValues}
              handleCheck={handleCheck}
              handleViewDetails={handleViewDetails}
              columns={columns}
              totalExpress={total}
              fromExpress={from}
              toExpress={to}
              handleExpresseRows={handleOrderChangeRows}
              rowsPerPageExpress={rowsPerPage}
              handleMultiplePrint={handleMultiplePrint}
              handleView={handleView}
              view={view}
              //handleRefetch={handleRefetch}
              currOrderNumbers={currOrderNumbers}
              handleKeyDownExpress={handleKeyDown}
              handleChangeSearchExpress={handleChangeSearch}
              setSearchText3={setSearchText}
              searchText3={searchText}
              handleChangeExpressTab={handleChangeExpressTab}
              expressIndex={props.expressIndex}
              openBackdrop={openBackdrop}
              backdropNumber={backdropNumber}
              loading={loading}
            />
          )}
        </CustomTabPanel>

        {/* Express Orders */}

        {/* Warehouse Orders */}
        <CustomTabPanel value={props.index} index={"to_prepare"}>
          <PreparingOrderComponent
            isMobile={isMobile}
            lastPage={lastPage}
            page={page}
            handleOrderChangePage={handleOrderChangePage}
            filteredData={filteredData}
            handlePrint={handlePrint}
            handlePickupOrder={handlePickupOrder}
            handlePickOrder={handlePickOrder}
            handleMultiplePick={handleMultiplePick}
            handleUnpickOrder={handleUnpickOrder}
            handleMultipleUnpick={handleMultipleUnpick}
            checkedValues={checkedValues}
            handleCheck={handleCheck}
            handleViewDetails={handleViewDetails}
            columns={columns}
            total={total}
            from={from}
            to={to}
            handleOrderChangeRows={handleOrderChangeRows}
            rowsPerPage={rowsPerPage}
            handleMultiplePrint={handleMultiplePrint}
            handleView={handleView}
            view={view}
            //handleRefetch={handleRefetch}
            currOrderNumbers={currOrderNumbers}
            handleKeyDown={handleKeyDown}
            handleChangeSearch={handleChangeSearch}
            setSearchText={setSearchText}
            searchText={searchText}
            handleChangeInstoretab={handleChangeInstoretab}
            instoreIndex={props.index}
            openBackdrop={openBackdrop}
            backdropNumber={backdropNumber}
            loading={loading}
          />
        </CustomTabPanel>
        {/* Warehouse Orders */}

        {/* Preparing orders */}
        <CustomTabPanel value={props.index} index={"pickup"}>
          <PickupList
            pickupList={pickupOrder?.sales_lines || []}
            order={orderDetails}
            setOrder={setOrderDetails}
            loading={loadingPreparing}
            pickupOrder={true}
            setValue={setValue}
            orderList={orderList}
            orderName={orderName}
            setOrderName={setOrderName}
            orderCode={orderCode}
            setOrderCode={setOrderCode}
            handleOrderFilter={handleOrderFilter}
            handleChangeOrder={handleChangeOrder}
            handleOrderCodeFilter={handleOrderCodeFilter}
            handlePrintTaxInvoice={handlePrintTaxInvoice}
            open1={open}
            setOpen1={setOpen}
            snackStatus={snackStatus}
            snackMessage1={snackMessage}
          />
        </CustomTabPanel>
        {/* Preparing orders */}


        {/* Notifications Tab */}
        <CustomTabPanel value={props.index} index={"notification"}>
          <Box
            pb={3}
            display={"flex"}
            flexDirection={isMobile ? "column" : "row"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Box flex={"1"}>
              <InputLabel>Search</InputLabel>
              <SearchBox display={"flex"}>
                <TextField
                  type="search"
                  variant="outlined"
                  name="searchNotification"
                  value={searchNotification}
                  onChange={handleSearchNotification}
                  onKeyDown={handleKeyDownNotification}
                  sx={{ width: "300px" }}
                />
              </SearchBox>
            </Box>
            <Box textAlign={"center"} flex="1" sx={{ marginTop: "10px" }}>
              <h2>Notification</h2>
            </Box>
            <Box textAlign={"right"} flex="1"></Box>
          </Box>

          <NotificationBox pb={2}>
            <span
              style={{
                cursor: "pointer",
                fontWeight: notificationType === "email" ? "700" : "400",
                background: notificationType === "email" ? "#1976d2" : "#fff",
                color: notificationType === "email" ? "#fff" : "inherit",
              }}
              onClick={() => setNotificationType("email")}
            >
              Email
            </span>

            <span
              style={{
                cursor: "pointer",
                fontWeight: notificationType === "sms" ? "700" : "400",
                background: notificationType === "sms" ? "#1976d2" : "#fff",
                color: notificationType === "sms" ? "#fff" : "inherit",
              }}
              onClick={() => setNotificationType("sms")}
            >
              SMS
            </span>
          </NotificationBox>
          {checkedValues.length > 0 ? (
            <Box textAlign={"right"} mb={2} mt={2}>

              <ButtonDropDown1
                checkedValues={checkedValues.length}
                handleClickPrint={handleMultiplePrintNots}
              />

            </Box>
          ) : (
            ""
          )}
          <Box>
            {!loadingNots ? (
              notificationType === "email" ? (
                <TableNotification
                  columns={columnsNotification}
                  rows={filteredData4}
                  total={totalNots}
                  from={fromNots}
                  to={toNots}
                  rowsPerPage={rowsPerPageNots}
                  page={pageNots}
                  handleChangePage={handleChangeNotificationPage}
                  handleChangeRowsPerPage={handleNotificationRows}
                  handleViewMessage={handleViewMessage}
                  handleResendMessage={handleResendMessage}
                  handleViewHistory={handleViewHistory}
                  // handleViewDetails={handleViewDetails}
                  handlePrint={handlePrintNots}
                  // fulfilled={true}
                  handleCheck={handleCheckNots}
                  checkedValues={checkedValues}
                  openBackdrop={openBackdrop}
                  backdropNumber={backdropNumber}
                />
              ) : (
                <TableNotification
                  columns={columnsNotificationSMS}
                  rows={filteredData4SMS}
                  total={totalNotsSMS}
                  from={fromNotsSMS}
                  to={toNotsSMS}
                  rowsPerPage={rowsPerPageNotsSMS}
                  page={pageNotsSMS}
                  handleChangePage={handleChangeNotificationPage}
                  handleChangeRowsPerPage={handleNotificationRows}
                  handleViewMessage={handleViewMessage}
                  handleResendMessage={handleResendMessage}
                  handleViewHistory={handleViewHistory}
                  // handleViewDetails={handleViewDetails}
                  handlePrint={handlePrintNots}
                  // fulfilled={true}
                  handleCheck={handleCheckNots}
                  checkedValues={checkedValues}
                  openBackdrop={openBackdrop}
                  backdropNumber={backdropNumber}
                />
              )
            ) : (
              <Box textAlign={"center"}>
                <CircularProgress />
              </Box>
            )}
          </Box>
        </CustomTabPanel>
        {/* Notifications Tab */}

        {/* Ready for Collection */}
        <CustomTabPanel value={props.index} index={"ready_to_be_picked"}>
          <Box
            pb={3}
            display={"flex"}
            alignItems={"center"}
            flexDirection={isMobile ? "column" : "row"}
            justifyContent={"space-between"}
          >
            <Box flex={"1"}>
              <InputLabel>Search</InputLabel>
              <SearchBox display={"flex"}>
                <TextField
                  type="search"
                  variant="outlined"
                  name="searchTextPicked"
                  value={searchTextPicked}
                  onChange={handleChangeSearchPicked}
                  // onChange={(e) => setSearchTextPicked(e.target.value)}
                  onKeyDown={handleKeyDownPicked}
                  helperText={
                    searchTextPicked
                      ? "Press enter to search Picked up Collections"
                      : ""
                  }
                  sx={{ width: "300px" }}
                />
              </SearchBox>
            </Box>
            <Box textAlign={"center"} flex="1" marginTop={"10px"}>
              <h2>Ready for Collection</h2>
            </Box>
            <Box flex={"1"}></Box>
          </Box>

          {/* Change View */}
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <SelectView handleView={handleView} />
            {checkedValues.length > 0 ? (
              <>
                <Box
                  textAlign={"right"}
                  display={"flex"}
                  gap="10px"
                  mb={2}
                  mr={2}
                >
                  {/* <ButtonDropDown
                    checkedValues={checkedValues.length}
                    handleClickPrint={handleMultiplePrint}
                  /> */}

                  <Button
                    color="secondary"
                    variant="contained"
                    onClick={handleMarkDialogue}
                  >
                    <DoneAllOutlined
                      fontSize="small"
                      style={{ marginRight: "5px" }}
                    />
                    {`Mark as Collected  (${markCheckValues.length})`}
                  </Button>
                </Box>
              </>
            ) : (
              ""
            )}
          </Box>

          {!loadingToPick ? (
            view !== 1 ? (
              <>
                <TableComponentView
                  columns={columnsReadyForCollection}
                  rows={filteredDataPicked}
                  total={totalPicked}
                  from={fromPicked}
                  to={toPicked}
                  rowsPerPage={rowsPerPagePicked}
                  page={pagePicked}
                  handleChangePage={handleChangePickedPage}
                  handleChangeRowsPerPage={handleChangePickedRows}
                  handleViewDetails={handleViewDetails}
                  // handlePrint={handlePrint}
                  handleMarkDialogueOrder={handleMarkDialogueOrder}
                  //handleMarkPick={handleMarkPick}
                  fulfilled={true}
                  fulfill={true}
                  handleCheck={handleCheck}
                  checkedValues={checkedValues}
                />
              </>
            ) : (
              <>
                <Masonry
                  columns={{ xs: 1, sm: 2, md: 3 }}
                  spacing={3}
                  sx={{ margin: "0", width: "auto" }}
                >
                  {filteredDataPicked &&
                    filteredDataPicked.map((order) => (
                      <Box key={order.id}>
                        <OrderCard
                          order={order}
                          markPick={true}
                          fulfill={true}
                          handleMarkPick={handleMarkDialogueOrder}
                        //handlePrint={handlePrint}
                        />
                      </Box>
                    ))}
                </Masonry>
                {filteredDataPicked.length ? (
                  <Box
                    alignItems={"center"}
                    justifyContent={"center"}
                    display={"flex"}
                  >
                    <Pagination
                      size="large"
                      count={lastPagePicked}
                      page={pagePicked}
                      onChange={handleChangePickedPage}
                      variant="outlined"
                      shape="rounded"
                      color="primary"
                    />
                  </Box>
                ) : (
                  ""
                )}
              </>
            )
          ) : (
            <Box textAlign={"center"}>
              <CircularProgress />
            </Box>
          )}
        </CustomTabPanel>
        {/* Ready for Collection */}

        {/* Invoiced */}
        <CustomTabPanel value={props.index} index={"invoiced"}>
          <Box
            pb={3}
            display={"flex"}
            alignItems={"center"}
            flexDirection={isMobile ? "column" : "row"}
            justifyContent={"space-between"}
          >
            <Box flex={"1"}>
              <InputLabel>Search</InputLabel>
              <SearchBox display={"flex"}>
                <TextField
                  type="search"
                  variant="outlined"
                  name="searchTextInvoiced"
                  value={searchTextInvoiced}
                  onChange={handleChangeSearchInvoiced}
                  // onChange={(e) => setSearchTextPicked(e.target.value)}
                  onKeyDown={handleKeyDownInvoiced}
                  helperText={
                    searchTextInvoiced
                      ? "Press enter to search Invoiced Orders"
                      : ""
                  }
                  sx={{ width: "300px" }}
                />
              </SearchBox>
            </Box>
            <Box textAlign={"center"} flex="1" marginTop={"10px"}>
              <h2>Invoiced Orders</h2>
            </Box>
            <Box flex={"1"}></Box>
          </Box>

          {/* Change View */}
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <SelectView handleView={handleView} />

          </Box>

          {!loadingInvoiced ? (
            view !== 1 ? (
              <>
                <TableComponentView
                  columns={columnsInvoiced}
                  rows={filteredDataInvoiced}
                  total={totalInvoiced}
                  from={fromInvoiced}
                  to={toInvoiced}
                  rowsPerPage={rowsPerPageInvoiced}
                  page={pageInvoiced}
                  handleChangePage={handleChangeInvoicedPage}
                  handleChangeRowsPerPage={handleChangeInvoicedRows}
                  handleViewDetails={handleViewDetails}
                  handleResendInvoice={handleResendInvoice}
                  // handlePrint={handlePrint}
                  //handleMarkDialogueOrder={handleMarkDialogueOrder}
                  //handleMarkPick={handleMarkPick}
                  //fulfilled={true}
                  print={true}
                  fulfill={true}
                  handleCheck={handleCheck}
                  checkedValues={checkedValues}
                />
              </>
            ) : (
              <>
                <Masonry
                  columns={{ xs: 1, sm: 2, md: 3 }}
                  spacing={3}
                  sx={{ margin: "0", width: "auto" }}
                >
                  {filteredDataInvoiced &&
                    filteredDataInvoiced.map((order) => (
                      <Box key={order.id}>
                        <OrderCard
                          order={order}
                          handleResendInvoice={handleResendInvoice}
                          fulfill={true}
                          print={true}
                        //handleMarkPick={handleMarkDialogueOrder}
                        //handlePrint={handlePrint}
                        />
                      </Box>
                    ))}
                </Masonry>
                {filteredDataInvoiced.length ? (
                  <Box
                    alignItems={"center"}
                    justifyContent={"center"}
                    display={"flex"}
                  >
                    <Pagination
                      size="large"
                      count={lastPageInvoiced}
                      page={pageInvoiced}
                      onChange={handleChangeInvoicedPage}
                      variant="outlined"
                      shape="rounded"
                      color="primary"
                    />
                  </Box>
                ) : (
                  ""
                )}
              </>
            )
          ) : (
            <Box textAlign={"center"}>
              <CircularProgress />
            </Box>
          )}
        </CustomTabPanel>
        {/* Invoiced */}

        {/* Picked */}
        <CustomTabPanel value={props.index} index={"picked"}>
          <Box
            pb={3}
            display={"flex"}
            alignItems={"center"}
            flexDirection={isMobile ? "column" : "row"}
            justifyContent={"space-between"}
          >
            <Box flex={"1"}>
              <InputLabel>Search</InputLabel>
              <SearchBox display={"flex"}>
                <TextField
                  type="search"
                  variant="outlined"
                  name="searchTextPicked"
                  value={searchTextPicked1}
                  onChange={handleChangeSearchPicked1}
                  // onChange={(e) => setSearchTextPicked(e.target.value)}
                  onKeyDown={handleKeyDownPicked1}
                  helperText={
                    searchTextPicked1
                      ? "Press enter to search Query History"
                      : ""
                  }
                  sx={{ width: "300px" }}
                />
              </SearchBox>
            </Box>
            <Box textAlign={"center"} flex="1" marginTop={"10px"}>
              <h2>Query History</h2>
            </Box>
            <Box flex={"1"}></Box>
          </Box>

          {/* Change View */}
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <SelectView handleView={handleView} />
            {/* {checkedValues.length > 0 ? (
              <>
                <Box
                  textAlign={"right"}
                  display={"flex"}
                  gap="10px"
                  mb={2}
                  mr={2}
                >
                

                  <Button
                    color="secondary"
                    variant="contained"
                    onClick={handleMarkDialogue}
                  >
                    <DoneAllOutlined
                      fontSize="small"
                      style={{ marginRight: "5px" }}
                    />
                    {`Mark as Collected  (${markCheckValues.length})`}
                  </Button>
                </Box>
              </>
            ) : (
              ""
            )} */}
          </Box>

          {!loadingToPick1 ? (
            view !== 1 ? (
              <>
                <TableComponentView
                  columns={columnsPicked}
                  rows={filteredDataPicked1}
                  total={totalPicked1}
                  from={fromPicked1}
                  to={toPicked1}
                  rowsPerPage={rowsPerPagePicked1}
                  page={pagePicked1}
                  handleChangePage={handleChangePickedPage1}
                  handleChangeRowsPerPage={handleChangePickedRows1}
                  handleViewDetails={handleViewDetails}
                  handleViewHistoryDetails={handleViewHistoryDetails}
                  // handlePrint={handlePrint}
                  // handleMarkDialogueOrder={handleMarkDialogueOrder}
                  //handleMarkPick={handleMarkPick}
                  //fulfilled={true}
                  fulfill={true}
                  handleCheck={handleCheck}
                  checkedValues={checkedValues}
                />
              </>
            ) : (
              <>
                <Masonry
                  columns={{ xs: 1, sm: 2, md: 3 }}
                  spacing={3}
                  sx={{ margin: "0", width: "auto" }}
                >
                  {filteredDataPicked1 &&
                    filteredDataPicked1.map((order) => (
                      <Box key={order.id}>
                        <OrderCard
                          order={order}
                          fulfill={true}
                          handleViewHistoryDetails={handleViewHistoryDetails}
                        //markPick={true}
                        //handleMarkPick={handleMarkDialogueOrder}
                        //handlePrint={handlePrint}
                        />
                      </Box>
                    ))}
                </Masonry>
                {filteredDataPicked1.length ? (
                  <Box
                    alignItems={"center"}
                    justifyContent={"center"}
                    display={"flex"}
                  >
                    <Pagination
                      size="large"
                      count={lastPagePicked1}
                      page={pagePicked1}
                      onChange={handleChangePickedPage1}
                      variant="outlined"
                      shape="rounded"
                      color="primary"
                    />
                  </Box>
                ) : (
                  ""
                )}
              </>
            )
          ) : (
            <Box textAlign={"center"}>
              <CircularProgress />
            </Box>
          )}
        </CustomTabPanel>
        {/* Picked */}
      </Box>
      {openMarkDialog && (
        <AddDetails


          sendToMark={sendToMark}
          sendToMarkOrder={sendToMarkOrder}
          order={orderPick}
          salesIDs={salesIDs}
          data={filteredDataPicked}


        />
      )}

      {showPrintDialog && (
        <PrintDialog
          printDetails={printDetails}
          callbackPrintPreview={callbackPrintPreview}
        />
      )}

      {openNotification && (
        <ViewNotification
          sendNotificationDetail={sendNotificationDetail}
          notificationDetails={notificationDetails}
        />
      )}

      {openHistoryDialog && (
        <ViewHistory
          sendHistoryCallback={sendHistoryCallback}
          historyDetails={historyDetails}
          notificationType={notificationType}
        />
      )}

      {openViewDetails && (
        <ViewWarehouseOrderList
          viewDetails={viewDetails}
          sendViewDetails={sendViewDetails}
          handleRePrintTaxInvoice={handleRePrintTaxInvoice}
          check={check}
          print={print}
        />
      )}

      {openViewHistoryDetails && (
        <ViewWarehouseOrderHistory
          viewDetails={viewHistoryDetails}
          sendViewDetails={sendViewHistoryDetails}
        />
      )}

      <Snackbar
        open={open}
        autoHideDuration={1000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleClose}
          severity={snackStatus}
          sx={{ width: "100%", position: "relative", top: "40px" }}
        >
          {snackMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default WarehouseOrders;
